
if (typeof (window) !== 'undefined' && window.performance && window.performance.mark) {
  window.performance.mark('yotpo:loader:loaded');
}
var yotpoWidgetsContainer = yotpoWidgetsContainer || { guids: {} };
(function(){
    var guid = "VurgePV_lmerI49HhCiiPQ";
    var loader = {
        loadDep: function (link, onLoad, strategy) {
            var script = document.createElement('script');
            script.onload = onLoad || function(){};
            script.src = link;
            if (strategy === 'defer') {
                script.defer = true;
            } else if (strategy === 'async') {
                script.async = true;
            }
            script.setAttribute("type", "text/javascript");
            script.setAttribute("charset", "utf-8");
            document.head.appendChild(script);
        },
        config: {
            data: {
                guid: guid
            },
            widgets: {
            
                "831400": {
                    instanceId: "831400",
                    instanceVersionId: "284553678",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.4-6731.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your Points",
                      "coupons-redemption-rule": "100 points equals $1",
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "login-button-color": "#0F8383",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "rounded_filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000FF",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "#0F8383",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "rule-color": "#000000FF",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "831399": {
                    instanceId: "831399",
                    instanceVersionId: "279141999",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.2.4-6294.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_08_15_17_49_13_975.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "false",
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": 48,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}}",
                      "logged-in-headline-color": "#000000FF",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "custom",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-primary-button-url": "https://www.blenderseyewear.com/cart",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000FF",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How it Works",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "rgba(0,41,112,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and start earning.",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": 18,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000FF",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_42_42_242",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "#000000FF",
                      "reward-step-1-settings-title-font-size": "20",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn 1 point per $1 spent. 100 points = $15.",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": 18,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000FF",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_43_42_627",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#000000FF",
                      "reward-step-2-settings-title-font-size": "20",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for exclusive sick discounts.Redeem points for exclusive sick discounts.",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": 18,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000FF",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_43_58_089",
                      "reward-step-3-settings-title": "REDEEM",
                      "reward-step-3-settings-title-color": "#000000FF",
                      "reward-step-3-settings-title-font-size": "20",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000FF",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(0,41,112,1)",
                      "secondary-button-text-color": "rgba(0,41,112,1)",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": true,
                      "view-grid-points-column-color": "rgba(0,41,112,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "831398": {
                    instanceId: "831398",
                    instanceVersionId: "279142110",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.1-5837.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_08_15_17_58_33_715.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(255,255,255,1)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "#000000FF",
                      "card-background-border-color": "#BCBCBC",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(255,255,255,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(1,18,71,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "rgba(224,229,233,1)",
                      "headline-font-size": 24,
                      "headline-text-color": "#000000FF",
                      "layout": "grid",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000FF",
                      "progress-bar-secondary-color": "#0F8383",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-19084-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-19084-design-icon-fill-color": "#0F8383",
                      "tiers-19084-design-icon-type": "none",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "true",
                      "tiers-19084-design-name-font-size": "18px",
                      "tiers-19084-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend",
                      "tiers-19084-text-name": "MOTION",
                      "tiers-19084-text-rank": 1,
                      "tiers-19084-text-threshold": "Free to join",
                      "tiers-7971-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-7971-design-icon-fill-color": "#0F8383",
                      "tiers-7971-design-icon-type": "none",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "true",
                      "tiers-7971-design-name-font-size": "18px",
                      "tiers-7971-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend||Power Up Reward\t||Exclusive Promotions\t||2x Points on New Drops\t||Free Shipping Events\t",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": 2,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "Blenders Rewards Membership Tiers"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "831397": {
                    instanceId: "831397",
                    instanceVersionId: "285438256",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000FF",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "831396": {
                    instanceId: "831396",
                    instanceVersionId: "287085089",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "carousel-custom-arrows-icons": false,
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#000000FF",
                      "headline-font-size": "36",
                      "image-ratio": "three_two",
                      "limit-one-free-product": "true",
                      "login-button-color": "rgba(0,120,212,1)",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "rgba(255,255,255,1)",
                      "login-button-type": "filled_rectangle",
                      "mobile-items-per-slide": 4,
                      "must-have-paid-product": "true",
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#000000FF",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "rgba(1,18,71,1)",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "rgba(1,18,71,1)",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "product-882813-displayname": "Orange Circuit - 6901951070277",
                      "product-882813-settings-background-border-color": "rgba(0,0,0,1)",
                      "product-882813-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882813-settings-background-has-shadow": "true",
                      "product-882813-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76752_1719454278.original.webp?1719454278",
                      "product-882813-settings-cancel-button-text-color": "rgba(0,120,212,1)",
                      "product-882813-settings-confirm-button-color": "rgba(0,120,212,1)",
                      "product-882813-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882813-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882813-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882813-settings-cost": 400,
                      "product-882813-settings-cost-color": "rgba(0,0,0,1)",
                      "product-882813-settings-cost-font-size": "20",
                      "product-882813-settings-cost-text": "{{points}} POINTS",
                      "product-882813-settings-hidden": "false",
                      "product-882813-settings-out-of-stock": "false",
                      "product-882813-settings-redeem-button-color": "rgba(0,120,212,1)",
                      "product-882813-settings-redeem-button-text": "REDEEM NOW",
                      "product-882813-settings-redeem-button-text-color": "rgba(255,255,255,1)",
                      "product-882813-settings-redeem-button-type": "filled_rectangle",
                      "product-882813-settings-restrict-specific-tier": "false",
                      "product-882813-settings-reward": "Orange Circuit ",
                      "product-882813-settings-reward-color": "rgba(0,0,0,1)",
                      "product-882813-settings-reward-font-size": "18",
                      "product-882813-settings-show-in-logged-out": "No",
                      "product-882813-settings-show-vip-tier-label": "false",
                      "product-882813-settings-variant-id": "40604292055109",
                      "product-882813-settings-vip-tier-label": "VIP ONLY",
                      "product-882814-displayname": "ORBR I - 6882979053637",
                      "product-882814-settings-background-border-color": "rgba(0,0,0,1)",
                      "product-882814-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882814-settings-background-has-shadow": "true",
                      "product-882814-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76753_1719454444.original.webp?1719454444",
                      "product-882814-settings-cancel-button-text-color": "rgba(0,120,212,1)",
                      "product-882814-settings-confirm-button-color": "rgba(0,120,212,1)",
                      "product-882814-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882814-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882814-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882814-settings-cost": 400,
                      "product-882814-settings-cost-color": "rgba(0,0,0,1)",
                      "product-882814-settings-cost-font-size": "20",
                      "product-882814-settings-cost-text": "{{points}} POINTS",
                      "product-882814-settings-hidden": "false",
                      "product-882814-settings-out-of-stock": "false",
                      "product-882814-settings-redeem-button-color": "rgba(0,120,212,1)",
                      "product-882814-settings-redeem-button-text": "REDEEM NOW",
                      "product-882814-settings-redeem-button-text-color": "rgba(255,255,255,1)",
                      "product-882814-settings-redeem-button-type": "filled_rectangle",
                      "product-882814-settings-restrict-specific-tier": "false",
                      "product-882814-settings-reward": "ORBR I",
                      "product-882814-settings-reward-color": "rgba(0,0,0,1)",
                      "product-882814-settings-reward-font-size": "18",
                      "product-882814-settings-show-in-logged-out": "No",
                      "product-882814-settings-show-vip-tier-label": "false",
                      "product-882814-settings-variant-id": "40539910963269",
                      "product-882814-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "882813",
                        "882814"
                      ],
                      "slides-next-button-image": "",
                      "slides-prev-button-image": "",
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyFunctionEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "mustHavePaidProduct": true,
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "831395": {
                    instanceId: "831395",
                    instanceVersionId: "279142112",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.2-6438.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_08_15_17_58_33_894.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_52_59_137",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16px",
                      "final-view-button-text": "REFER MORE",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "fonts-secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "header-color": "rgba(255,255,255,1)",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba(0,120,212,1)",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "#FFFFFF",
                      "next-button-type": "filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(255,255,255,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(255,255,255,1)",
                      "title-font-size": "48px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "true",
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "rgba(255,255,255,1)",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "831394": {
                    instanceId: "831394",
                    instanceVersionId: "279141998",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.6.0-6588.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_08_15_17_49_13_888.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_41_38_617",
                      "description-color": "rgba(0,0,0,0)",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,0)",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-in-non-member": "Welcome to the club",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "LOG IN",
                      "login-button-text-color": "#000000FF",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to Page Settings",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_41_36_045",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Join now",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "831393": {
                    instanceId: "831393",
                    instanceVersionId: "279142107",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.1.2-6192.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_08_15_17_49_13_680.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-522517-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-description-font-size": "16",
                      "campaign-item-522517-exclude_audience_ids": null,
                      "campaign-item-522517-exclude_audience_names": [],
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-522517-special-reward-headline-title-font-size": "12",
                      "campaign-item-522517-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-title-font-size": "18",
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-description-font-size": "16",
                      "campaign-item-522518-exclude_audience_ids": null,
                      "campaign-item-522518-exclude_audience_names": [],
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-522518-special-reward-headline-title-font-size": "12",
                      "campaign-item-522518-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-title-font-size": "18",
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your birthday",
                      "campaign-item-522519-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-description-font-size": "16",
                      "campaign-item-522519-exclude_audience_ids": null,
                      "campaign-item-522519-exclude_audience_names": [],
                      "campaign-item-522519-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-522519-special-reward-headline-title-font-size": "12",
                      "campaign-item-522519-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "100 points",
                      "campaign-item-522519-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-title-font-size": "18",
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-description-font-size": "16",
                      "campaign-item-522735-exclude_audience_ids": null,
                      "campaign-item-522735-exclude_audience_names": [],
                      "campaign-item-522735-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-522735-special-reward-headline-title-font-size": "12",
                      "campaign-item-522735-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-title-font-size": "18",
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-description-font-size": "16",
                      "campaign-item-522736-exclude_audience_ids": null,
                      "campaign-item-522736-exclude_audience_names": [],
                      "campaign-item-522736-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522736-icon-type": "customIcon",
                      "campaign-item-522736-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_08_15_17_48_02_410",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-522736-special-reward-headline-title-font-size": "12",
                      "campaign-item-522736-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-title-font-size": "18",
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-525098-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-description-font-size": "16",
                      "campaign-item-525098-exclude_audience_ids": null,
                      "campaign-item-525098-exclude_audience_names": [],
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#000000FF",
                      "campaign-item-525098-special-reward-headline-title-font-size": "12",
                      "campaign-item-525098-special-reward-tile-border-color": "#000000FF",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-title-font-size": "18",
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(1,18,71,1)",
                      "general-hover-tile-button-type": "rounded_filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(1,18,71,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000FF",
                      "headline-font-size": "26px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-text-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522736",
                        "525098",
                        "522518",
                        "522519"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000FF",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000FF",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "831392": {
                    instanceId: "831392",
                    instanceVersionId: "287085092",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.0-6569.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "page-background-color": "",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-opt-in-join-now-button-label": "Join now",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#000000FF",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-widgets-ids": [
                        "831394",
                        "831399",
                        "831393",
                        "831396",
                        "831398",
                        "831395"
                      ],
                      "widget-831393-type": "CampaignWidget",
                      "widget-831394-type": "HeroSectionWidget",
                      "widget-831395-type": "ReferralWidget",
                      "widget-831396-type": "ProductsRedemptionWidget",
                      "widget-831397-type": "VisualRedemptionWidget",
                      "widget-831398-type": "VipTiersWidget",
                      "widget-831399-type": "MyRewardsWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "829166": {
                    instanceId: "829166",
                    instanceVersionId: "285438369",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000FF",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "829165": {
                    instanceId: "829165",
                    instanceVersionId: "278953024",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.1-5632.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_58_20_567.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_12_26_59_375",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16px",
                      "final-view-button-text": "REFER MORE",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "fonts-secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "header-color": "rgba(255,255,255,1)",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba(0,120,212,1)",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "#FFFFFF",
                      "next-button-type": "filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(255,255,255,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(255,255,255,1)",
                      "title-font-size": "48px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "true",
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "rgba(255,255,255,1)",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "829164": {
                    instanceId: "829164",
                    instanceVersionId: "278953023",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.1-5837.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_44_29_888.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(255,255,255,1)",
                      "benefits-icon-type": "default",
                      "benefits-icon-url": "",
                      "benefits-text-color": "#000000FF",
                      "card-background-border-color": "#BCBCBC",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(255,255,255,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(1,18,71,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "rgba(224,229,233,1)",
                      "headline-font-size": 24,
                      "headline-text-color": "#000000FF",
                      "layout": "grid",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000FF",
                      "progress-bar-secondary-color": "rgba(0,120,212,1)",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-19084-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-19084-design-icon-fill-color": "#0F8383",
                      "tiers-19084-design-icon-type": "none",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "true",
                      "tiers-19084-design-name-font-size": "18px",
                      "tiers-19084-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t",
                      "tiers-19084-text-name": "MOTION",
                      "tiers-19084-text-rank": 1,
                      "tiers-19084-text-threshold": "Free to join",
                      "tiers-7971-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-7971-design-icon-fill-color": "#0F8383",
                      "tiers-7971-design-icon-type": "none",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "true",
                      "tiers-7971-design-name-font-size": "18px",
                      "tiers-7971-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t||Power Up Reward\t||Early Access to New Products\t||Exclusive Promotions\t||2x Points on New Drops\t||Free Shipping Events\t",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": 2,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "Blenders Rewards Membership Tiers"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "829163": {
                    instanceId: "829163",
                    instanceVersionId: "278953021",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.1.0-5680.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_53_36_531.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-522517-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-description-font-size": 14,
                      "campaign-item-522517-exclude_audience_ids": null,
                      "campaign-item-522517-exclude_audience_names": [],
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522517-special-reward-headline-title-font-size": "12",
                      "campaign-item-522517-special-reward-tile-border-color": "#000000",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-title-font-size": 16,
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-description-font-size": 14,
                      "campaign-item-522518-exclude_audience_ids": null,
                      "campaign-item-522518-exclude_audience_names": [],
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522518-special-reward-headline-title-font-size": "12",
                      "campaign-item-522518-special-reward-tile-border-color": "#000000",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-title-font-size": 16,
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your birthday",
                      "campaign-item-522519-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-description-font-size": 14,
                      "campaign-item-522519-exclude_audience_ids": null,
                      "campaign-item-522519-exclude_audience_names": [],
                      "campaign-item-522519-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522519-special-reward-headline-title-font-size": "12",
                      "campaign-item-522519-special-reward-tile-border-color": "#000000",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "100 points",
                      "campaign-item-522519-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-title-font-size": 16,
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-description-font-size": 14,
                      "campaign-item-522735-exclude_audience_ids": null,
                      "campaign-item-522735-exclude_audience_names": [],
                      "campaign-item-522735-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522735-special-reward-headline-title-font-size": "12",
                      "campaign-item-522735-special-reward-tile-border-color": "#000000",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-title-font-size": 16,
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-description-font-size": 14,
                      "campaign-item-522736-exclude_audience_ids": null,
                      "campaign-item-522736-exclude_audience_names": [],
                      "campaign-item-522736-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522736-icon-type": "customIcon",
                      "campaign-item-522736-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_26_12_51_03_051",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522736-special-reward-headline-title-font-size": "12",
                      "campaign-item-522736-special-reward-tile-border-color": "#000000",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-title-font-size": 16,
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-525098-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-description-font-size": 14,
                      "campaign-item-525098-exclude_audience_ids": null,
                      "campaign-item-525098-exclude_audience_names": [],
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-525098-special-reward-headline-title-font-size": "12",
                      "campaign-item-525098-special-reward-tile-border-color": "#000000",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-title-font-size": 16,
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(1,18,71,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(1,18,71,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000FF",
                      "headline-font-size": "26px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-text-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522736",
                        "525098",
                        "522518",
                        "522519"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000FF",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000FF",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "big",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "829162": {
                    instanceId: "829162",
                    instanceVersionId: "278953020",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.2.2-5825.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_29_17_04_43_750.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "false",
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": 48,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}}",
                      "logged-in-headline-color": "#000000FF",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "custom",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-primary-button-url": "https://www.blenderseyewear.com/cart",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000FF",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "rgba(0,41,112,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and start earning.",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": 18,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000FF",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_27_999",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "#000000FF",
                      "reward-step-1-settings-title-font-size": 18,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn 1 point per $1 spent. 100 points = $15.",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": 18,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000FF",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_19_929",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#000000FF",
                      "reward-step-2-settings-title-font-size": 18,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for exclusive sick discounts.",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": 18,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000FF",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_08_251",
                      "reward-step-3-settings-title": "REDEEM",
                      "reward-step-3-settings-title-color": "#000000FF",
                      "reward-step-3-settings-title-font-size": 18,
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000FF",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(0,41,112,1)",
                      "secondary-button-text-color": "rgba(0,41,112,1)",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": true,
                      "view-grid-points-column-color": "rgba(0,120,212,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "829161": {
                    instanceId: "829161",
                    instanceVersionId: "278953019",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.0.6-5758.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_25_12_41_57_345.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_58_23_103",
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,0)",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "SIGN IN",
                      "login-button-text-color": "#000000FF",
                      "login-button-type": "filled_rectangle",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_59_04_685",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "SIGN UP",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "829160": {
                    instanceId: "829160",
                    instanceVersionId: "278953030",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.0-6569.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "page-background-color": "",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-widgets-ids": [
                        "829161",
                        "829162",
                        "829163",
                        "829164",
                        "829165"
                      ],
                      "widget-829161-type": "HeroSectionWidget",
                      "widget-829162-type": "MyRewardsWidget",
                      "widget-829163-type": "CampaignWidget",
                      "widget-829164-type": "VipTiersWidget",
                      "widget-829165-type": "ReferralWidget",
                      "widget-829166-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "platformName": "shopify"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "808265": {
                    instanceId: "808265",
                    instanceVersionId: "279421838",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-product-points/app.v0.3.10-6482.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "icon-color": "#000000FF",
                      "icon-type": "defaultIcon",
                      "logged-in-text": "Earn **{{points_amount}} points** for this product with [Blenders Eyewear  Rewards](http://www.blenderseyewear.com/pages/rewards)",
                      "logged-out-text": "Earn **{{points_amount}} points** for this product. [Log in or sign up](https://www.blenderseyewear.com/account/login)",
                      "show-background-enabled": false,
                      "view-background-color": "#FCEEF1",
                      "view-link-color": "#D1577E",
                      "view-link-style-underline": true,
                      "view-points-color": "#000000FF",
                      "view-primary-font": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "view-secondary-font": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "view-text-color": "#000000FF",
                      "view-text-size": "12px"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isOptInFlowEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeId": "7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK",
                      "storeLoginUrl": "https://www.blenderseyewear.com/account/login"
                    },
                    className: "ProductPoints",
                    dependencyGroupId: null
                },
            
                "804765": {
                    instanceId: "804765",
                    instanceVersionId: "286130003",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "carousel-custom-arrows-icons": false,
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#000000FF",
                      "headline-font-size": 26,
                      "image-ratio": "three_two",
                      "limit-one-free-product": "true",
                      "login-button-color": "rgba(0,0,0,1)",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "rectangular_outline",
                      "mobile-items-per-slide": 4,
                      "must-have-paid-product": "true",
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#000000FF",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000FF",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "rgba(0,0,0,1)",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "product-882813-displayname": "Orange Circuit - 6901951070277",
                      "product-882813-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-882813-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882813-settings-background-has-shadow": false,
                      "product-882813-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76752_1719454278.original.webp?1719454278",
                      "product-882813-settings-cancel-button-text-color": "rgba(0,0,0,1)",
                      "product-882813-settings-confirm-button-color": "rgba(0,0,0,1)",
                      "product-882813-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882813-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882813-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882813-settings-cost": "400",
                      "product-882813-settings-cost-color": "#000000FF",
                      "product-882813-settings-cost-font-size": "20",
                      "product-882813-settings-cost-text": "{{points}} POINTS",
                      "product-882813-settings-hidden": "false",
                      "product-882813-settings-out-of-stock": "false",
                      "product-882813-settings-redeem-button-color": "rgba(0,0,0,1)",
                      "product-882813-settings-redeem-button-text": "REDEEM NOW",
                      "product-882813-settings-redeem-button-text-color": "rgba(0,0,0,1)",
                      "product-882813-settings-redeem-button-type": "rectangular_outline",
                      "product-882813-settings-restrict-specific-tier": "false",
                      "product-882813-settings-reward": "Orange Circuit",
                      "product-882813-settings-reward-color": "#000000FF",
                      "product-882813-settings-reward-font-size": "18",
                      "product-882813-settings-show-in-logged-out": "No",
                      "product-882813-settings-show-vip-tier-label": "false",
                      "product-882813-settings-variant-id": "40604292055109",
                      "product-882813-settings-vip-tier-label": "VIP ONLY",
                      "product-882814-displayname": "ORBR I - 6882979053637",
                      "product-882814-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-882814-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882814-settings-background-has-shadow": false,
                      "product-882814-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76753_1719454444.original.webp?1719454444",
                      "product-882814-settings-cancel-button-text-color": "rgba(0,0,0,1)",
                      "product-882814-settings-confirm-button-color": "rgba(0,0,0,1)",
                      "product-882814-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882814-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882814-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882814-settings-cost": "400",
                      "product-882814-settings-cost-color": "#000000FF",
                      "product-882814-settings-cost-font-size": "20",
                      "product-882814-settings-cost-text": "{{points}} POINTS",
                      "product-882814-settings-hidden": "false",
                      "product-882814-settings-out-of-stock": "false",
                      "product-882814-settings-redeem-button-color": "rgba(0,0,0,1)",
                      "product-882814-settings-redeem-button-text": "REDEEM NOW",
                      "product-882814-settings-redeem-button-text-color": "rgba(0,0,0,1)",
                      "product-882814-settings-redeem-button-type": "rectangular_outline",
                      "product-882814-settings-restrict-specific-tier": "false",
                      "product-882814-settings-reward": "ORBR I",
                      "product-882814-settings-reward-color": "#000000FF",
                      "product-882814-settings-reward-font-size": "18",
                      "product-882814-settings-show-in-logged-out": "No",
                      "product-882814-settings-show-vip-tier-label": "false",
                      "product-882814-settings-variant-id": "40539910963269",
                      "product-882814-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "882813",
                        "882814"
                      ],
                      "slides-next-button-image": "",
                      "slides-prev-button-image": "",
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyFunctionEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "mustHavePaidProduct": true,
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "804329": {
                    instanceId: "804329",
                    instanceVersionId: "285439478",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000FF",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "804328": {
                    instanceId: "804328",
                    instanceVersionId: "268986425",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.1-5632.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_58_20_567.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_12_26_59_375",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16px",
                      "final-view-button-text": "REFER MORE",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "fonts-secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "header-color": "rgba(255,255,255,1)",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba(0,120,212,1)",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "#FFFFFF",
                      "next-button-type": "filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Earn $20 off for every time you refer a friend who spends over $50.00",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(255,255,255,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(255,255,255,1)",
                      "title-font-size": "48px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "true",
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "rgba(255,255,255,1)",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "804327": {
                    instanceId: "804327",
                    instanceVersionId: "268986416",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.1-5837.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_44_29_888.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(255,255,255,1)",
                      "benefits-icon-type": "default",
                      "benefits-icon-url": "",
                      "benefits-text-color": "#000000FF",
                      "card-background-border-color": "#BCBCBC",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(255,255,255,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(1,18,71,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "rgba(224,229,233,1)",
                      "headline-font-size": 24,
                      "headline-text-color": "#000000FF",
                      "layout": "grid",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000FF",
                      "progress-bar-secondary-color": "rgba(0,120,212,1)",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-19084-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-19084-design-icon-fill-color": "#0F8383",
                      "tiers-19084-design-icon-type": "none",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "true",
                      "tiers-19084-design-name-font-size": "18px",
                      "tiers-19084-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t",
                      "tiers-19084-text-name": "MOTION",
                      "tiers-19084-text-rank": 1,
                      "tiers-19084-text-threshold": "Free to join",
                      "tiers-7971-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-7971-design-icon-fill-color": "#0F8383",
                      "tiers-7971-design-icon-type": "none",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "true",
                      "tiers-7971-design-name-font-size": "18px",
                      "tiers-7971-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t||Power Up Reward\t||Early Access to New Products\t||Exclusive Promotions\t||2x Points on New Drops\t||Free Shipping Events\t",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": 2,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "Blenders Rewards Membership Tiers"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "804326": {
                    instanceId: "804326",
                    instanceVersionId: "268986408",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.1.0-5680.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_53_36_531.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-522517-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-description-font-size": 14,
                      "campaign-item-522517-exclude_audience_ids": null,
                      "campaign-item-522517-exclude_audience_names": [],
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522517-special-reward-headline-title-font-size": "12",
                      "campaign-item-522517-special-reward-tile-border-color": "#000000",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-title-font-size": 16,
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-description-font-size": 14,
                      "campaign-item-522518-exclude_audience_ids": null,
                      "campaign-item-522518-exclude_audience_names": [],
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522518-special-reward-headline-title-font-size": "12",
                      "campaign-item-522518-special-reward-tile-border-color": "#000000",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-title-font-size": 16,
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your birthday",
                      "campaign-item-522519-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-description-font-size": 14,
                      "campaign-item-522519-exclude_audience_ids": null,
                      "campaign-item-522519-exclude_audience_names": [],
                      "campaign-item-522519-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522519-special-reward-headline-title-font-size": "12",
                      "campaign-item-522519-special-reward-tile-border-color": "#000000",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "100 points",
                      "campaign-item-522519-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-title-font-size": 16,
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-description-font-size": 14,
                      "campaign-item-522735-exclude_audience_ids": null,
                      "campaign-item-522735-exclude_audience_names": [],
                      "campaign-item-522735-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522735-special-reward-headline-title-font-size": "12",
                      "campaign-item-522735-special-reward-tile-border-color": "#000000",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-title-font-size": 16,
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-description-font-size": 14,
                      "campaign-item-522736-exclude_audience_ids": null,
                      "campaign-item-522736-exclude_audience_names": [],
                      "campaign-item-522736-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522736-icon-type": "customIcon",
                      "campaign-item-522736-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_26_12_51_03_051",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522736-special-reward-headline-title-font-size": "12",
                      "campaign-item-522736-special-reward-tile-border-color": "#000000",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-title-font-size": 16,
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-525098-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-description-font-size": 14,
                      "campaign-item-525098-exclude_audience_ids": null,
                      "campaign-item-525098-exclude_audience_names": [],
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-525098-special-reward-headline-title-font-size": "12",
                      "campaign-item-525098-special-reward-tile-border-color": "#000000",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-title-font-size": 16,
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(1,18,71,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(1,18,71,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000FF",
                      "headline-font-size": "26px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-text-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522736",
                        "525098",
                        "522518",
                        "522519"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000FF",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000FF",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "big",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "804325": {
                    instanceId: "804325",
                    instanceVersionId: "268986397",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.2.2-5825.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_29_17_04_43_750.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "false",
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": 48,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}}",
                      "logged-in-headline-color": "#000000FF",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "custom",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-primary-button-url": "https://www.blenderseyewear.com/cart",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000FF",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "rgba(0,41,112,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and start earning.",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": 18,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000FF",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_27_999",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "#000000FF",
                      "reward-step-1-settings-title-font-size": 18,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn 1 point per $1 spent. 100 points = $15.",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": 18,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000FF",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_19_929",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#000000FF",
                      "reward-step-2-settings-title-font-size": 18,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for exclusive sick discounts.",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": 18,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000FF",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_08_251",
                      "reward-step-3-settings-title": "REDEEM",
                      "reward-step-3-settings-title-color": "#000000FF",
                      "reward-step-3-settings-title-font-size": 18,
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000FF",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(0,41,112,1)",
                      "secondary-button-text-color": "rgba(0,41,112,1)",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": true,
                      "view-grid-points-column-color": "rgba(0,120,212,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "804324": {
                    instanceId: "804324",
                    instanceVersionId: "268986388",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.0.6-5758.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_25_12_41_57_345.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_58_23_103",
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,0)",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "SIGN IN",
                      "login-button-text-color": "#000000FF",
                      "login-button-type": "filled_rectangle",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_59_04_685",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "SIGN UP",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "804323": {
                    instanceId: "804323",
                    instanceVersionId: "268986445",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.0-6569.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "page-background-color": "",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-widgets-ids": [
                        "804324",
                        "804325",
                        "804326",
                        "804327",
                        "804328"
                      ],
                      "widget-804324-type": "HeroSectionWidget",
                      "widget-804325-type": "MyRewardsWidget",
                      "widget-804326-type": "CampaignWidget",
                      "widget-804327-type": "VipTiersWidget",
                      "widget-804328-type": "ReferralWidget",
                      "widget-804329-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "platformName": "shopify"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "786153": {
                    instanceId: "786153",
                    instanceVersionId: "286130271",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#000000FF",
                      "headline-font-size": "36",
                      "image-ratio": "three_four",
                      "login-button-color": "#0f0c6d",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "#0f0c6d",
                      "login-button-type": "rectangular_outline",
                      "mobile-items-per-slide": 4,
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#000000FF",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000FF",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "product-882813-displayname": "Orange Circuit - 6901951070277",
                      "product-882813-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-882813-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882813-settings-background-has-shadow": false,
                      "product-882813-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76752_1719454278.original.webp?1719454278",
                      "product-882813-settings-cancel-button-text-color": "#0f0c6d",
                      "product-882813-settings-confirm-button-color": "#0f0c6d",
                      "product-882813-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882813-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882813-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882813-settings-cost": 100,
                      "product-882813-settings-cost-color": "#000000FF",
                      "product-882813-settings-cost-font-size": "20",
                      "product-882813-settings-cost-text": "{{points}} POINTS",
                      "product-882813-settings-hidden": "false",
                      "product-882813-settings-out-of-stock": "false",
                      "product-882813-settings-redeem-button-color": "#0f0c6d",
                      "product-882813-settings-redeem-button-text": "REDEEM NOW",
                      "product-882813-settings-redeem-button-text-color": "#0f0c6d",
                      "product-882813-settings-redeem-button-type": "rectangular_outline",
                      "product-882813-settings-restrict-specific-tier": "false",
                      "product-882813-settings-reward": "Orange Circuit - 6901951070277",
                      "product-882813-settings-reward-color": "#000000FF",
                      "product-882813-settings-reward-font-size": "18",
                      "product-882813-settings-show-in-logged-out": "No",
                      "product-882813-settings-show-vip-tier-label": "false",
                      "product-882813-settings-variant-id": "40604292055109",
                      "product-882813-settings-vip-tier-label": "VIP ONLY",
                      "product-882814-displayname": "ORBR I - 6882979053637",
                      "product-882814-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-882814-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-882814-settings-background-has-shadow": false,
                      "product-882814-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/76753_1719454444.original.webp?1719454444",
                      "product-882814-settings-cancel-button-text-color": "#0f0c6d",
                      "product-882814-settings-confirm-button-color": "#0f0c6d",
                      "product-882814-settings-confirm-button-text-color": "#FFFFFF",
                      "product-882814-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-882814-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-882814-settings-cost": 100,
                      "product-882814-settings-cost-color": "#000000FF",
                      "product-882814-settings-cost-font-size": "20",
                      "product-882814-settings-cost-text": "{{points}} POINTS",
                      "product-882814-settings-hidden": "false",
                      "product-882814-settings-out-of-stock": "false",
                      "product-882814-settings-redeem-button-color": "#0f0c6d",
                      "product-882814-settings-redeem-button-text": "REDEEM NOW",
                      "product-882814-settings-redeem-button-text-color": "#0f0c6d",
                      "product-882814-settings-redeem-button-type": "rectangular_outline",
                      "product-882814-settings-restrict-specific-tier": "false",
                      "product-882814-settings-reward": "ORBR I - 6882979053637",
                      "product-882814-settings-reward-color": "#000000FF",
                      "product-882814-settings-reward-font-size": "18",
                      "product-882814-settings-show-in-logged-out": "No",
                      "product-882814-settings-show-vip-tier-label": "false",
                      "product-882814-settings-variant-id": "40539910963269",
                      "product-882814-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "882813",
                        "882814"
                      ],
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyFunctionEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "58582",
                      "mustHavePaidProduct": true,
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "780900": {
                    instanceId: "780900",
                    instanceVersionId: "286130201",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "image-ratio": "three_four",
                      "login-button-color": "#0f0c6d",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "#0f0c6d",
                      "login-button-type": "rectangular_outline",
                      "mobile-items-per-slide": 4,
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#011247",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "product-325713-displayname": "Yankee Rose",
                      "product-325713-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-has-shadow": false,
                      "product-325713-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11666_1581461608.original.jpg?1581461608",
                      "product-325713-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325713-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325713-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325713-settings-cost": 250,
                      "product-325713-settings-cost-text": "{{points}} POINTS",
                      "product-325713-settings-hidden": "false",
                      "product-325713-settings-out-of-stock": "false",
                      "product-325713-settings-redeem-button-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-text": "REDEEM NOW",
                      "product-325713-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-type": "rectangular_outline",
                      "product-325713-settings-restrict-specific-tier": "false",
                      "product-325713-settings-reward": "Yankee Rose",
                      "product-325713-settings-reward-color": "#011247",
                      "product-325713-settings-reward-font-size": "8",
                      "product-325713-settings-show-in-logged-out": "No",
                      "product-325713-settings-show-vip-tier-label": "false",
                      "product-325713-settings-variant-id": "16999172243525",
                      "product-325713-settings-vip-tier-label": "VIP ONLY",
                      "product-325714-displayname": "Sunz Up",
                      "product-325714-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-has-shadow": false,
                      "product-325714-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11740_1581628990.original.jpg?1581628990",
                      "product-325714-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325714-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325714-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325714-settings-cost": 200,
                      "product-325714-settings-cost-text": "{{points}} POINTS",
                      "product-325714-settings-hidden": "false",
                      "product-325714-settings-out-of-stock": "false",
                      "product-325714-settings-redeem-button-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-text": "REDEEM NOW",
                      "product-325714-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-type": "rectangular_outline",
                      "product-325714-settings-restrict-specific-tier": "false",
                      "product-325714-settings-reward": "Sunz Up",
                      "product-325714-settings-reward-color": "#011247",
                      "product-325714-settings-reward-font-size": "8",
                      "product-325714-settings-show-in-logged-out": "No",
                      "product-325714-settings-show-vip-tier-label": "false",
                      "product-325714-settings-variant-id": "29442975629381",
                      "product-325714-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "selected-extensions": [
                        "325713",
                        "325714"
                      ],
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "780899": {
                    instanceId: "780899",
                    instanceVersionId: "261574879",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_19_46_488",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "default-toggle": true,
                      "description-color": "rgba( 55, 51, 48, 1 )",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "header-color": "rgba( 0, 0, 0, 1 )",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba( 85, 131, 66, 1 )",
                      "next-button-font-size": "18px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba( 85, 131, 66, 1 )",
                      "next-button-type": "rectangular_outline",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-description": "You’ll love {{company_name}} as much as I do",
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba( 255, 255, 255, 1 )",
                      "title-color": "rgba( 55, 51, 48, 1 )",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "780898": {
                    instanceId: "780898",
                    instanceVersionId: "261574878",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v0.6.1-4815.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "layout-background-color": "white",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#666d8b",
                      "redemption-1-settings-cost-font-size": "20",
                      "redemption-1-settings-reward": "$0",
                      "redemption-1-settings-reward-color": "#011247",
                      "redemption-1-settings-reward-font-size": "30",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#666d8b",
                      "redemption-2-settings-cost-font-size": "20",
                      "redemption-2-settings-reward": "$0",
                      "redemption-2-settings-reward-color": "#011247",
                      "redemption-2-settings-reward-font-size": "30",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#666d8b",
                      "redemption-3-settings-cost-font-size": "20",
                      "redemption-3-settings-reward": "$0",
                      "redemption-3-settings-reward-color": "#011247",
                      "redemption-3-settings-reward-font-size": "30",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your hard-earned points is easy! Simply apply your points for a discount at checkout!",
                      "visual-redemption-headline": "How to use your points",
                      "visual-redemption-rule": "100 points equals $10.00"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "780897": {
                    instanceId: "780897",
                    instanceVersionId: "261574877",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v0.13.0-4770.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-522517-background-color": "#f9faff",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "#848ca3",
                      "campaign-item-522517-description-font-color": "#4e5772",
                      "campaign-item-522517-description-font-size": "18",
                      "campaign-item-522517-exclude_audience_names": "",
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "#768cdc",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": "All customers",
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522517-special-reward-headline-title-font-size": "16",
                      "campaign-item-522517-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "#011247",
                      "campaign-item-522517-title-font-size": "27",
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "#f9faff",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "#848ca3",
                      "campaign-item-522518-description-font-color": "#4e5772",
                      "campaign-item-522518-description-font-size": "18",
                      "campaign-item-522518-exclude_audience_names": "",
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "#768cdc",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": "All customers",
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522518-special-reward-headline-title-font-size": "16",
                      "campaign-item-522518-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "#011247",
                      "campaign-item-522518-title-font-size": "27",
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-action-text": "Add My Birthday",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your Birthday!",
                      "campaign-item-522519-background-color": "#f9faff",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "#848ca3",
                      "campaign-item-522519-description-font-color": "#4e5772",
                      "campaign-item-522519-description-font-size": "18",
                      "campaign-item-522519-exclude_audience_names": "",
                      "campaign-item-522519-icon-color": "#768cdc",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": "All customers",
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522519-special-reward-headline-title-font-size": "16",
                      "campaign-item-522519-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "Earn 100 points on your Birthday!",
                      "campaign-item-522519-title-font-color": "#011247",
                      "campaign-item-522519-title-font-size": "27",
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522732-background-color": "#f9faff",
                      "campaign-item-522732-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522732-background-type": "color",
                      "campaign-item-522732-border-color": "#848ca3",
                      "campaign-item-522732-description-font-color": "#4e5772",
                      "campaign-item-522732-description-font-size": "18",
                      "campaign-item-522732-exclude_audience_names": "",
                      "campaign-item-522732-hover-view-tile-message": "Earn 50 points when you spend over $100 at our store",
                      "campaign-item-522732-icon-color": "#768cdc",
                      "campaign-item-522732-icon-type": "defaultIcon",
                      "campaign-item-522732-include_audience_ids": "1",
                      "campaign-item-522732-include_audience_names": "All customers",
                      "campaign-item-522732-special-reward-enabled": "false",
                      "campaign-item-522732-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522732-special-reward-headline-text": "Just for you!",
                      "campaign-item-522732-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522732-special-reward-headline-title-font-size": "16",
                      "campaign-item-522732-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522732-tile-description": "Spend Over $100",
                      "campaign-item-522732-tile-reward": "50 Points",
                      "campaign-item-522732-title-font-color": "#011247",
                      "campaign-item-522732-title-font-size": "27",
                      "campaign-item-522732-type": "SpendBasedCampaign",
                      "campaign-item-522733-background-color": "#f9faff",
                      "campaign-item-522733-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522733-background-type": "color",
                      "campaign-item-522733-border-color": "#848ca3",
                      "campaign-item-522733-description-font-color": "#4e5772",
                      "campaign-item-522733-description-font-size": "18",
                      "campaign-item-522733-exclude_audience_names": "",
                      "campaign-item-522733-hover-view-tile-message": "Earn 75 points when you spend over $150 at our store",
                      "campaign-item-522733-icon-color": "#768cdc",
                      "campaign-item-522733-icon-type": "defaultIcon",
                      "campaign-item-522733-include_audience_ids": "1",
                      "campaign-item-522733-include_audience_names": "All customers",
                      "campaign-item-522733-special-reward-enabled": "false",
                      "campaign-item-522733-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522733-special-reward-headline-text": "Just for you!",
                      "campaign-item-522733-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522733-special-reward-headline-title-font-size": "16",
                      "campaign-item-522733-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522733-tile-description": "Spend Over $150",
                      "campaign-item-522733-tile-reward": "75 Points",
                      "campaign-item-522733-title-font-color": "#011247",
                      "campaign-item-522733-title-font-size": "27",
                      "campaign-item-522733-type": "SpendBasedCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "#f9faff",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "#848ca3",
                      "campaign-item-522735-description-font-color": "#4e5772",
                      "campaign-item-522735-description-font-size": "18",
                      "campaign-item-522735-exclude_audience_names": "",
                      "campaign-item-522735-icon-color": "#768cdc",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": "All customers",
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522735-special-reward-headline-title-font-size": "16",
                      "campaign-item-522735-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "#011247",
                      "campaign-item-522735-title-font-size": "27",
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "#f9faff",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "#848ca3",
                      "campaign-item-522736-description-font-color": "#4e5772",
                      "campaign-item-522736-description-font-size": "18",
                      "campaign-item-522736-exclude_audience_names": "",
                      "campaign-item-522736-icon-color": "#768cdc",
                      "campaign-item-522736-icon-type": "defaultIcon",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": "All customers",
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522736-special-reward-headline-title-font-size": "16",
                      "campaign-item-522736-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "#011247",
                      "campaign-item-522736-title-font-size": "27",
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-522737-action-tile-action-text": "Follow Us",
                      "campaign-item-522737-action-tile-title": "Earn 5 points when you follow us on Twitter",
                      "campaign-item-522737-background-color": "#f9faff",
                      "campaign-item-522737-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522737-background-type": "color",
                      "campaign-item-522737-border-color": "#848ca3",
                      "campaign-item-522737-description-font-color": "#4e5772",
                      "campaign-item-522737-description-font-size": "18",
                      "campaign-item-522737-displayname": "campaign-item-522737",
                      "campaign-item-522737-icon-color": "#768cdc",
                      "campaign-item-522737-icon-type": "defaultIcon",
                      "campaign-item-522737-tile-description": "Follow us on Twitter",
                      "campaign-item-522737-tile-reward": "5 Points",
                      "campaign-item-522737-title-font-color": "#011247",
                      "campaign-item-522737-title-font-size": "27",
                      "campaign-item-522737-type": "TwitterFollowCampaign",
                      "campaign-item-522737-view-show-custom-action-button": "false",
                      "campaign-item-525059-action-tile-action-text": "Click Here",
                      "campaign-item-525059-action-tile-title": "Earn 10 points by writing us a review on Facebook and sending a screenshot of your review to mermaids@blenderseyewear.com",
                      "campaign-item-525059-background-color": "#f9faff",
                      "campaign-item-525059-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525059-background-type": "color",
                      "campaign-item-525059-border-color": "#848ca3",
                      "campaign-item-525059-description-font-color": "#4e5772",
                      "campaign-item-525059-description-font-size": "18",
                      "campaign-item-525059-displayname": "campaign-item-525059",
                      "campaign-item-525059-icon-color": "#768cdc",
                      "campaign-item-525059-icon-type": "defaultIcon",
                      "campaign-item-525059-tile-description": "Review us on Facebook",
                      "campaign-item-525059-tile-reward": "10 Points",
                      "campaign-item-525059-title-font-color": "#011247",
                      "campaign-item-525059-title-font-size": "27",
                      "campaign-item-525059-type": "CustomActionCampaign",
                      "campaign-item-525059-view-show-custom-action-button": "false",
                      "campaign-item-525098-background-color": "#f9faff",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "#848ca3",
                      "campaign-item-525098-description-font-color": "#4e5772",
                      "campaign-item-525098-description-font-size": "18",
                      "campaign-item-525098-exclude_audience_names": "",
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "#768cdc",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": "All customers",
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-525098-special-reward-headline-title-font-size": "16",
                      "campaign-item-525098-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "#011247",
                      "campaign-item-525098-title-font-size": "27",
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-item-582318-action-tile-action-text": "Click here",
                      "campaign-item-582318-action-tile-title": "Earn points for an action",
                      "campaign-item-582318-background-color": "#f9faff",
                      "campaign-item-582318-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-582318-background-type": "color",
                      "campaign-item-582318-border-color": "#848ca3",
                      "campaign-item-582318-description-font-color": "#4e5772",
                      "campaign-item-582318-description-font-size": "18",
                      "campaign-item-582318-displayname": "campaign-item-582318",
                      "campaign-item-582318-hover-view-tile-message": "Upload a photo with your next review and earn 20 points",
                      "campaign-item-582318-icon-color": "#768cdc",
                      "campaign-item-582318-icon-type": "defaultIcon",
                      "campaign-item-582318-tile-description": "Add photo in Review",
                      "campaign-item-582318-tile-reward": "20 points",
                      "campaign-item-582318-title-font-color": "#011247",
                      "campaign-item-582318-title-font-size": "27",
                      "campaign-item-582318-type": "YotpoReviewImageCampaign",
                      "campaign-item-582318-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to earn points",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "#140060",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "#011247",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "#011247",
                      "headline-font-size": "36px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522737",
                        "522736",
                        "525059",
                        "525098",
                        "582318",
                        "522518",
                        "522732",
                        "522733",
                        "522519"
                      ],
                      "tile-border-color": "#848ca3",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "780896": {
                    instanceId: "780896",
                    instanceVersionId: "261574876",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v0.3.3-4897.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "#728be2",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "#011247",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "#011247",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "primary-button-background-color": "#728be2",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nget 100 points.",
                      "reward-step-1-settings-description-color": "#666d8b",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-title": "SIGN UP",
                      "reward-step-1-settings-title-color": "#011247",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#666d8b",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#b7c6f8",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#011247",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "#666d8b",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#b7c6f8",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "#011247",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "secondary-button-background-color": "#768cdc",
                      "secondary-button-text-color": "#768cdc",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "780895": {
                    instanceId: "780895",
                    instanceVersionId: "261574875",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v0.2.1-4807.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_15_59_898",
                      "description-color": "rgba(44,44,44,1)",
                      "description-font-size": "20",
                      "description-text-logged-in": "As a member you'll earn points \u0026 exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points \u0026 exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,1)",
                      "headline-font-size": "40",
                      "headline-text-logged-in": "Welcome to Blenders Rewards",
                      "headline-text-logged-out": "Blenders Rewards",
                      "login-button-color": "rgba(44,44,44,1)",
                      "login-button-text": "LOGIN",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "rectangular_outline",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_18_20_582",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "register-button-color": "rgba(0,0,0,1)",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "rgba(255,255,255,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "634439": {
                    instanceId: "634439",
                    instanceVersionId: "261730387",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.1.0-5680.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_53_36_531.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-522517-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-description-font-size": 14,
                      "campaign-item-522517-exclude_audience_ids": null,
                      "campaign-item-522517-exclude_audience_names": [],
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522517-special-reward-headline-title-font-size": "12",
                      "campaign-item-522517-special-reward-tile-border-color": "#000000",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-title-font-size": 16,
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-description-font-size": 14,
                      "campaign-item-522518-exclude_audience_ids": null,
                      "campaign-item-522518-exclude_audience_names": [],
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522518-special-reward-headline-title-font-size": "12",
                      "campaign-item-522518-special-reward-tile-border-color": "#000000",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-title-font-size": 16,
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your birthday",
                      "campaign-item-522519-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-description-font-size": 14,
                      "campaign-item-522519-exclude_audience_ids": null,
                      "campaign-item-522519-exclude_audience_names": [],
                      "campaign-item-522519-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522519-special-reward-headline-title-font-size": "12",
                      "campaign-item-522519-special-reward-tile-border-color": "#000000",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "100 points",
                      "campaign-item-522519-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-title-font-size": 16,
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-description-font-size": 14,
                      "campaign-item-522735-exclude_audience_ids": null,
                      "campaign-item-522735-exclude_audience_names": [],
                      "campaign-item-522735-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522735-special-reward-headline-title-font-size": "12",
                      "campaign-item-522735-special-reward-tile-border-color": "#000000",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-title-font-size": 16,
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-description-font-size": 14,
                      "campaign-item-522736-exclude_audience_ids": null,
                      "campaign-item-522736-exclude_audience_names": [],
                      "campaign-item-522736-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522736-icon-type": "customIcon",
                      "campaign-item-522736-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_26_12_51_03_051",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-522736-special-reward-headline-title-font-size": "12",
                      "campaign-item-522736-special-reward-tile-border-color": "#000000",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-title-font-size": 16,
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-525098-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-description-font-size": 14,
                      "campaign-item-525098-exclude_audience_ids": null,
                      "campaign-item-525098-exclude_audience_names": [],
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-525098-special-reward-headline-title-font-size": "12",
                      "campaign-item-525098-special-reward-tile-border-color": "#000000",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-title-font-size": 16,
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(1,18,71,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(1,18,71,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000FF",
                      "headline-font-size": "26px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "secondary-text-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522736",
                        "525098",
                        "522518",
                        "522519"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000FF",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000FF",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "big",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "634438": {
                    instanceId: "634438",
                    instanceVersionId: "272610888",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.2.2-5825.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_29_17_04_43_750.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "false",
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": 48,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}}",
                      "logged-in-headline-color": "#000000FF",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "custom",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-primary-button-url": "https://www.blenderseyewear.com/cart",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000FF",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_2",
                      "primary-button-background-color": "rgba(0,41,112,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and start earning.",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": 18,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000FF",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_27_999",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "#000000FF",
                      "reward-step-1-settings-title-font-size": 18,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn 1 point per $1 spent. 100 points = $15 off.",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": 18,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000FF",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_19_929",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#000000FF",
                      "reward-step-2-settings-title-font-size": 18,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for exclusive sick discounts.",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": 18,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000FF",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_11_48_08_251",
                      "reward-step-3-settings-title": "REDEEM",
                      "reward-step-3-settings-title-color": "#000000FF",
                      "reward-step-3-settings-title-font-size": 18,
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000FF",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(0,41,112,1)",
                      "secondary-button-text-color": "rgba(0,41,112,1)",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": true,
                      "view-grid-points-column-color": "rgba(0,120,212,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "634437": {
                    instanceId: "634437",
                    instanceVersionId: "42249278",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.1-5837.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_44_29_888.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(255,255,255,1)",
                      "benefits-icon-type": "default",
                      "benefits-icon-url": "",
                      "benefits-text-color": "#000000FF",
                      "card-background-border-color": "#BCBCBC",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(255,255,255,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(1,18,71,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "rgba(224,229,233,1)",
                      "headline-font-size": 24,
                      "headline-text-color": "#000000FF",
                      "layout": "grid",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000FF",
                      "progress-bar-secondary-color": "rgba(0,120,212,1)",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-19084-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-19084-design-icon-fill-color": "#0F8383",
                      "tiers-19084-design-icon-type": "none",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "true",
                      "tiers-19084-design-name-font-size": "18px",
                      "tiers-19084-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-19084-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t",
                      "tiers-19084-text-name": "MOTION",
                      "tiers-19084-text-rank": 1,
                      "tiers-19084-text-threshold": "Free to join",
                      "tiers-7971-design-header-bg-color": "rgba(35,43,56,1)",
                      "tiers-7971-design-icon-fill-color": "#0F8383",
                      "tiers-7971-design-icon-type": "none",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "true",
                      "tiers-7971-design-name-font-size": "18px",
                      "tiers-7971-design-name-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "rgba(255,255,255,1)",
                      "tiers-7971-text-benefits": "Earn 1 Point for $1 Spent\t||100 Points = $15 Off\t||Refer a Friend\t||Power Up Reward\t||Early Access to New Products\t||Exclusive Promotions\t||2x Points on New Drops\t||Free Shipping Events\t",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": 2,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "Blenders Rewards Membership Tiers"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "634436": {
                    instanceId: "634436",
                    instanceVersionId: "278115715",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.1-5632.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_26_12_58_20_567.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_25_12_26_59_375",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Earn $20 off for every time you refer a friend who spends over $50",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16px",
                      "final-view-button-text": "REFER MORE",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "fonts-secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "header-color": "rgba(255,255,255,1)",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba(0,120,212,1)",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "#FFFFFF",
                      "next-button-type": "filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Earn $20 off for every time you refer a friend who spends over $50",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(255,255,255,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(255,255,255,1)",
                      "title-font-size": "48px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "true",
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "rgba(255,255,255,1)",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "634435": {
                    instanceId: "634435",
                    instanceVersionId: "285444443",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000FF",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "634434": {
                    instanceId: "634434",
                    instanceVersionId: "284559620",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.4-6731.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your Points",
                      "coupons-redemption-rule": "100 points equals $1",
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "login-button-color": "#0F8383",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "rounded_filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "#0F8383",
                      "primary-font-name-and-url": "Poppins@600|https://fonts.googleapis.com/css?family=Poppins:600\u0026display=swap",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://fonts.googleapis.com/css?family=Poppins:400\u0026display=swap",
                      "selected-extensions": [],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "634433": {
                    instanceId: "634433",
                    instanceVersionId: "42117406",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.0.6-5758.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2024_02_25_12_41_57_345.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_58_23_103",
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,0)",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "SIGN IN",
                      "login-button-text-color": "#000000FF",
                      "login-button-type": "filled_rectangle",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_02_22_15_59_04_685",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "SIGN UP",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "634432": {
                    instanceId: "634432",
                    instanceVersionId: "278115714",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.0-6569.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "#000000FF",
                      "headline-font-size": "26",
                      "page-background-color": "",
                      "primary-font-name-and-url": "AktivGroteskEx@700|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/aktivgroteskex/aktivgroteskex_bd-700.css",
                      "reward-opt-in-join-now-button-label": "Join now",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "basis-grotesque@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK/basis-grotesque/basis-grotesque-regular-400.css",
                      "selected-widgets-ids": [
                        "634433",
                        "634438",
                        "634439",
                        "634437",
                        "634436"
                      ],
                      "widget-634433-type": "HeroSectionWidget",
                      "widget-634435-type": "VisualRedemptionWidget",
                      "widget-634436-type": "ReferralWidget",
                      "widget-634437-type": "VipTiersWidget",
                      "widget-634438-type": "MyRewardsWidget",
                      "widget-634439-type": "CampaignWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "platformName": "shopify"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "489021": {
                    instanceId: "489021",
                    instanceVersionId: "255168589",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-customer-preview/app.v0.2.8-6189.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "view-background-color": "transparent",
                      "view-primary-color": "#2e4f7c",
                      "view-primary-font": "Nunito Sans@700|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/nunito_sans/v1/nunito_sans_700.css",
                      "view-text-color": "#202020",
                      "welcome-text": "Good morning"
                    },
                    staticContent: {
                      "currency": "USD",
                      "hideIfMatchingQueryParam": [
                        "oseid"
                      ],
                      "isHidden": true,
                      "platformName": "shopify",
                      "selfExecutable": true,
                      "storeId": "7Na4Xsq5Vf0s5VxSDIrDl56IRsBb1HHiohLKFKOK",
                      "storeLoginUrl": "http://www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "http://www.blenderseyewear.com/account/register",
                      "storeRewardsPageUrl": "http://www.blenderseyewear.com/pages/rewards",
                      "urlMatch": "^(?!.*\\.yotpo\\.com).*$"
                    },
                    className: "CustomerPreview",
                    dependencyGroupId: null
                },
            
                "105852": {
                    instanceId: "105852",
                    instanceVersionId: "261574433",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v0.13.0-4770.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-522517-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "rgba(132,140,163,0)",
                      "campaign-item-522517-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-description-font-size": 14,
                      "campaign-item-522517-exclude_audience_names": "",
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": "All customers",
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522517-special-reward-headline-title-font-size": "16",
                      "campaign-item-522517-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522517-title-font-size": 20,
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "rgba(132,140,163,0)",
                      "campaign-item-522518-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-description-font-size": 14,
                      "campaign-item-522518-exclude_audience_names": "",
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": "All customers",
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522518-special-reward-headline-title-font-size": "16",
                      "campaign-item-522518-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522518-title-font-size": 20,
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-action-text": "Add My Birthday",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": "",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your Birthday!",
                      "campaign-item-522519-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "rgba(132,140,163,0)",
                      "campaign-item-522519-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-description-font-size": 14,
                      "campaign-item-522519-exclude_audience_names": "",
                      "campaign-item-522519-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": "All customers",
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522519-special-reward-headline-title-font-size": "16",
                      "campaign-item-522519-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "100 Birthday Points!",
                      "campaign-item-522519-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522519-title-font-size": 20,
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "rgba(132,140,163,0)",
                      "campaign-item-522735-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-description-font-size": 14,
                      "campaign-item-522735-exclude_audience_names": "",
                      "campaign-item-522735-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": "All customers",
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522735-special-reward-headline-title-font-size": "16",
                      "campaign-item-522735-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522735-title-font-size": 20,
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "rgba(132,140,163,0)",
                      "campaign-item-522736-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-description-font-size": 14,
                      "campaign-item-522736-exclude_audience_names": "",
                      "campaign-item-522736-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-522736-icon-type": "defaultIcon",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": "All customers",
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522736-special-reward-headline-title-font-size": "16",
                      "campaign-item-522736-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-522736-title-font-size": 20,
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-525098-background-color": "rgba(255,255,255,0.15)",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "rgba(132,140,163,0)",
                      "campaign-item-525098-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-description-font-size": 14,
                      "campaign-item-525098-exclude_audience_names": "",
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "rgba(35,43,56,1)",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": "All customers",
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-525098-special-reward-headline-title-font-size": "16",
                      "campaign-item-525098-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-525098-title-font-size": 20,
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "#140060",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "#011247",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "#011247",
                      "headline-font-size": 16,
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522519",
                        "522518",
                        "522736",
                        "522735",
                        "525098"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#E0DBEF",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#5344A6",
                      "special-reward-headline-title-font-size": "16",
                      "special-reward-tile-border-color": "#8270E7",
                      "tile-border-color": "#848ca3",
                      "tile-spacing-type": "big",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "105839": {
                    instanceId: "105839",
                    instanceVersionId: "36737281",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v0.3.3-4897.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "#728be2",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "#011247",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "#011247",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "primary-button-background-color": "#728be2",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nget 100 points.",
                      "reward-step-1-settings-description-color": "#666d8b",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-title": "SIGN UP",
                      "reward-step-1-settings-title-color": "#011247",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#666d8b",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#b7c6f8",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#011247",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "#666d8b",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#b7c6f8",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "#011247",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#768cdc",
                      "secondary-button-text-color": "#768cdc",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "105838": {
                    instanceId: "105838",
                    instanceVersionId: "25749543",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v0.13.0-4770.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-522517-background-color": "#f9faff",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "#848ca3",
                      "campaign-item-522517-description-font-color": "#4e5772",
                      "campaign-item-522517-description-font-size": "18",
                      "campaign-item-522517-exclude_audience_ids": null,
                      "campaign-item-522517-exclude_audience_names": [],
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "#768cdc",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522517-special-reward-headline-title-font-size": "16",
                      "campaign-item-522517-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "#011247",
                      "campaign-item-522517-title-font-size": "27",
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "#f9faff",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "#848ca3",
                      "campaign-item-522518-description-font-color": "#4e5772",
                      "campaign-item-522518-description-font-size": "18",
                      "campaign-item-522518-exclude_audience_ids": null,
                      "campaign-item-522518-exclude_audience_names": [],
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "#768cdc",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522518-special-reward-headline-title-font-size": "16",
                      "campaign-item-522518-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "#011247",
                      "campaign-item-522518-title-font-size": "27",
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-action-text": "Add My Birthday",
                      "campaign-item-522519-action-tile-birthday-ask-year": "false",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-title": "Earn 10 points on your Birthday!",
                      "campaign-item-522519-background-color": "#f9faff",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "#848ca3",
                      "campaign-item-522519-description-font-color": "#4e5772",
                      "campaign-item-522519-description-font-size": "18",
                      "campaign-item-522519-exclude_audience_ids": null,
                      "campaign-item-522519-exclude_audience_names": [],
                      "campaign-item-522519-icon-color": "#768cdc",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522519-special-reward-headline-title-font-size": "16",
                      "campaign-item-522519-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "Earn 10 points on your Birthday!",
                      "campaign-item-522519-title-font-color": "#011247",
                      "campaign-item-522519-title-font-size": "27",
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522732-background-color": "#f9faff",
                      "campaign-item-522732-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522732-background-type": "color",
                      "campaign-item-522732-border-color": "#848ca3",
                      "campaign-item-522732-description-font-color": "#4e5772",
                      "campaign-item-522732-description-font-size": "18",
                      "campaign-item-522732-exclude_audience_ids": null,
                      "campaign-item-522732-exclude_audience_names": [],
                      "campaign-item-522732-hover-view-tile-message": "Earn 50 points when you spend over $100 at our store",
                      "campaign-item-522732-icon-color": "#768cdc",
                      "campaign-item-522732-icon-type": "defaultIcon",
                      "campaign-item-522732-include_audience_ids": "1",
                      "campaign-item-522732-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522732-special-reward-enabled": "false",
                      "campaign-item-522732-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522732-special-reward-headline-text": "Just for you!",
                      "campaign-item-522732-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522732-special-reward-headline-title-font-size": "16",
                      "campaign-item-522732-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522732-tile-description": "Spend Over $100",
                      "campaign-item-522732-tile-reward": "50 Points",
                      "campaign-item-522732-title-font-color": "#011247",
                      "campaign-item-522732-title-font-size": "27",
                      "campaign-item-522732-type": "SpendBasedCampaign",
                      "campaign-item-522733-background-color": "#f9faff",
                      "campaign-item-522733-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522733-background-type": "color",
                      "campaign-item-522733-border-color": "#848ca3",
                      "campaign-item-522733-description-font-color": "#4e5772",
                      "campaign-item-522733-description-font-size": "18",
                      "campaign-item-522733-exclude_audience_ids": null,
                      "campaign-item-522733-exclude_audience_names": [],
                      "campaign-item-522733-hover-view-tile-message": "Earn 75 points when you spend over $150 at our store",
                      "campaign-item-522733-icon-color": "#768cdc",
                      "campaign-item-522733-icon-type": "defaultIcon",
                      "campaign-item-522733-include_audience_ids": "1",
                      "campaign-item-522733-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522733-special-reward-enabled": "false",
                      "campaign-item-522733-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522733-special-reward-headline-text": "Just for you!",
                      "campaign-item-522733-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522733-special-reward-headline-title-font-size": "16",
                      "campaign-item-522733-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522733-tile-description": "Spend Over $150",
                      "campaign-item-522733-tile-reward": "75 Points",
                      "campaign-item-522733-title-font-color": "#011247",
                      "campaign-item-522733-title-font-size": "27",
                      "campaign-item-522733-type": "SpendBasedCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "#f9faff",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "#848ca3",
                      "campaign-item-522735-description-font-color": "#4e5772",
                      "campaign-item-522735-description-font-size": "18",
                      "campaign-item-522735-exclude_audience_ids": null,
                      "campaign-item-522735-exclude_audience_names": [],
                      "campaign-item-522735-icon-color": "#768cdc",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522735-special-reward-headline-title-font-size": "16",
                      "campaign-item-522735-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "#011247",
                      "campaign-item-522735-title-font-size": "27",
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "#f9faff",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "#848ca3",
                      "campaign-item-522736-description-font-color": "#4e5772",
                      "campaign-item-522736-description-font-size": "18",
                      "campaign-item-522736-exclude_audience_ids": null,
                      "campaign-item-522736-exclude_audience_names": [],
                      "campaign-item-522736-icon-color": "#768cdc",
                      "campaign-item-522736-icon-type": "defaultIcon",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522736-special-reward-headline-title-font-size": "16",
                      "campaign-item-522736-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "#011247",
                      "campaign-item-522736-title-font-size": "27",
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-522737-action-tile-action-text": "Follow Us",
                      "campaign-item-522737-action-tile-title": "Earn 5 points when you follow us on Twitter",
                      "campaign-item-522737-background-color": "#f9faff",
                      "campaign-item-522737-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522737-background-type": "color",
                      "campaign-item-522737-border-color": "#848ca3",
                      "campaign-item-522737-description-font-color": "#4e5772",
                      "campaign-item-522737-description-font-size": "18",
                      "campaign-item-522737-exclude_audience_ids": null,
                      "campaign-item-522737-exclude_audience_names": [],
                      "campaign-item-522737-icon-color": "#768cdc",
                      "campaign-item-522737-icon-type": "defaultIcon",
                      "campaign-item-522737-include_audience_ids": "1",
                      "campaign-item-522737-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-522737-special-reward-enabled": "false",
                      "campaign-item-522737-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522737-special-reward-headline-text": "Just for you!",
                      "campaign-item-522737-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522737-special-reward-headline-title-font-size": "16",
                      "campaign-item-522737-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522737-tile-description": "Follow us on Twitter",
                      "campaign-item-522737-tile-reward": "5 Points",
                      "campaign-item-522737-title-font-color": "#011247",
                      "campaign-item-522737-title-font-size": "27",
                      "campaign-item-522737-type": "TwitterFollowCampaign",
                      "campaign-item-525098-background-color": "#f9faff",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "#848ca3",
                      "campaign-item-525098-description-font-color": "#4e5772",
                      "campaign-item-525098-description-font-size": "18",
                      "campaign-item-525098-exclude_audience_ids": null,
                      "campaign-item-525098-exclude_audience_names": [],
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "#768cdc",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-525098-special-reward-headline-title-font-size": "16",
                      "campaign-item-525098-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "#011247",
                      "campaign-item-525098-title-font-size": "27",
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-item-582318-background-color": "#f9faff",
                      "campaign-item-582318-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-582318-background-type": "color",
                      "campaign-item-582318-border-color": "#848ca3",
                      "campaign-item-582318-description-font-color": "#4e5772",
                      "campaign-item-582318-description-font-size": "18",
                      "campaign-item-582318-exclude_audience_ids": null,
                      "campaign-item-582318-exclude_audience_names": [],
                      "campaign-item-582318-hover-view-tile-message": "Upload a photo with your next review and earn 20 points",
                      "campaign-item-582318-icon-color": "#768cdc",
                      "campaign-item-582318-icon-type": "defaultIcon",
                      "campaign-item-582318-include_audience_ids": "1",
                      "campaign-item-582318-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-582318-special-reward-enabled": "false",
                      "campaign-item-582318-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-582318-special-reward-headline-text": "Just for you!",
                      "campaign-item-582318-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-582318-special-reward-headline-title-font-size": "16",
                      "campaign-item-582318-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-582318-tile-description": "Add photo in Review",
                      "campaign-item-582318-tile-reward": "20 points",
                      "campaign-item-582318-title-font-color": "#011247",
                      "campaign-item-582318-title-font-size": "27",
                      "campaign-item-582318-type": "YotpoReviewImageCampaign",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to earn points",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "#140060",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "#011247",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "#011247",
                      "headline-font-size": "36px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522737",
                        "522736",
                        "525098",
                        "582318",
                        "522732",
                        "522733",
                        "522518",
                        "522519"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#E0DBEF",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#5344A6",
                      "special-reward-headline-title-font-size": "16",
                      "special-reward-tile-border-color": "#8270E7",
                      "tile-border-color": "#848ca3",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "105837": {
                    instanceId: "105837",
                    instanceVersionId: "26076223",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v0.2.1-4807.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/BackgroundImage.jpg",
                      "description-color": "#0F0C6D",
                      "description-font-size": "20",
                      "description-text-logged-in": "As a member you'll earn points \u0026 exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points \u0026 exclusive rewards every time you shop.",
                      "headline-color": "#0a0f5f",
                      "headline-font-size": "40",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "#0f0c6d",
                      "login-button-text": "LOGIN",
                      "login-button-text-color": "#0f0c6d",
                      "login-button-type": "rectangular_outline",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/MobileBackgroundImage.jpg",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "register-button-color": "#0f0c6d",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "#ffffff",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "105836": {
                    instanceId: "105836",
                    instanceVersionId: "24357615",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/widget-referral-widget/customizations/defaults/BackgroundImage-v3.jpg",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba( 55, 51, 48, 1 )",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "header-color": "rgba( 0, 0, 0, 1 )",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-font-size": "18px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-type": "rectangular_outline",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba( 255, 255, 255, 1 )",
                      "title-color": "rgba( 55, 51, 48, 1 )",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "105835": {
                    instanceId: "105835",
                    instanceVersionId: "26135987",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v0.6.1-4815.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "layout-background-color": "white",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#666d8b",
                      "redemption-1-settings-cost-font-size": "20",
                      "redemption-1-settings-reward": "$0",
                      "redemption-1-settings-reward-color": "#011247",
                      "redemption-1-settings-reward-font-size": "30",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#666d8b",
                      "redemption-2-settings-cost-font-size": "20",
                      "redemption-2-settings-reward": "$0",
                      "redemption-2-settings-reward-color": "#011247",
                      "redemption-2-settings-reward-font-size": "30",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#666d8b",
                      "redemption-3-settings-cost-font-size": "20",
                      "redemption-3-settings-reward": "$0",
                      "redemption-3-settings-reward-color": "#011247",
                      "redemption-3-settings-reward-font-size": "30",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your hard-earned points is easy! Simply apply your points for a discount at checkout!",
                      "visual-redemption-headline": "How to use your points",
                      "visual-redemption-rule": "100 points equals $10.00"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "105834": {
                    instanceId: "105834",
                    instanceVersionId: "27090201",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v1.2.3-4884.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "benefits-font-size": "18px",
                      "benefits-icon-color": "rgb(115,142,217)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "#000000",
                      "card-background-border-color": "#C9CDD9",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "true",
                      "card-separator-color": "#AAAAAA",
                      "card-separator-type": "default",
                      "current-status-bg-color": "#FFFFFF",
                      "current-status-text-color": "#000000",
                      "current-tier-border-color": "#727898",
                      "grid-lines-color": "#ACB5D4",
                      "headline-font-size": "36px",
                      "headline-text-color": "#011247",
                      "layout": "card",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#011247",
                      "progress-bar-secondary-color": "#768cdc",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier Status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "Montserrat@500|https://fonts.googleapis.com/css?family=Montserrat:500\u0026display=swap",
                      "selected-extensions": [
                        "7971",
                        "7972",
                        "7973"
                      ],
                      "show-less-text": "- Show Less",
                      "show-more-text": "+ Show More",
                      "tier-spacing": "big",
                      "tiers-7971-design-header-bg-color": "#FFFFFF",
                      "tiers-7971-design-icon-fill-color": "#6c89e9",
                      "tiers-7971-design-icon-type": "default",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "false",
                      "tiers-7971-design-name-font-size": "22px",
                      "tiers-7971-design-name-text-color": "#011247",
                      "tiers-7971-design-threshold-font-size": "18px",
                      "tiers-7971-design-threshold-text-color": "#727898",
                      "tiers-7971-text-benefits": "Benefit 1||Benefit 2||Benefit 3",
                      "tiers-7971-text-name": "Bronze",
                      "tiers-7971-text-rank": 1,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "tiers-7972-design-header-bg-color": "#FFFFFF",
                      "tiers-7972-design-icon-fill-color": "#6c89e9",
                      "tiers-7972-design-icon-type": "default",
                      "tiers-7972-design-icon-url": "",
                      "tiers-7972-design-include-header-bg": "false",
                      "tiers-7972-design-name-font-size": "22px",
                      "tiers-7972-design-name-text-color": "#011247",
                      "tiers-7972-design-threshold-font-size": "18px",
                      "tiers-7972-design-threshold-text-color": "#727898",
                      "tiers-7972-text-benefits": "Benefit 1||Benefit 2||Benefit 3",
                      "tiers-7972-text-name": "Silver",
                      "tiers-7972-text-rank": 2,
                      "tiers-7972-text-threshold": "Spend {{amount_spent}}",
                      "tiers-7973-design-header-bg-color": "#FFFFFF",
                      "tiers-7973-design-icon-fill-color": "#6c89e9",
                      "tiers-7973-design-icon-type": "default",
                      "tiers-7973-design-icon-url": "",
                      "tiers-7973-design-include-header-bg": "false",
                      "tiers-7973-design-name-font-size": "22px",
                      "tiers-7973-design-name-text-color": "#011247",
                      "tiers-7973-design-threshold-font-size": "18px",
                      "tiers-7973-design-threshold-text-color": "#727898",
                      "tiers-7973-text-benefits": "Benefit 1||Benefit 2||Benefit 3",
                      "tiers-7973-text-name": "Gold",
                      "tiers-7973-text-rank": 3,
                      "tiers-7973-text-threshold": "Spend {{amount_spent}}",
                      "widget-background-color": "#f5f5f5",
                      "widget-headline": "The VIP Club"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "105833": {
                    instanceId: "105833",
                    instanceVersionId: "30991426",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v0.6.2-5198.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "NO",
                      "confirmation-step-confirm-option": "YES",
                      "confirmation-step-title": "ARE YOU SURE?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout.",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "COPIED",
                      "coupons-redemption-description": "Redeeming your points is easy! Click Redeem My Points and copy \u0026 paste your code at checkout.",
                      "coupons-redemption-headline": "How to use your points",
                      "coupons-redemption-rule": "100 points equals $10.00",
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "disabled-outline-button-color": "#929292",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "DONATE",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "SUCCESS",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "login-button-color": "#556DD8",
                      "login-button-text": "REDEEM MY POINTS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "20",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redeem-button-color": "#556DD8",
                      "redeem-button-text": "REDEEM",
                      "redeem-button-text-color": "white",
                      "redeem-button-type": "filled_rectangle",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "105832": {
                    instanceId: "105832",
                    instanceVersionId: "286135414",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "image-ratio": "three_four",
                      "login-button-color": "#0f0c6d",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "#0f0c6d",
                      "login-button-type": "rectangular_outline",
                      "mobile-items-per-slide": 4,
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#011247",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "product-325713-displayname": "Yankee Rose",
                      "product-325713-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-has-shadow": false,
                      "product-325713-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11666_1581461608.original.jpg?1581461608",
                      "product-325713-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325713-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325713-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325713-settings-cost": 250,
                      "product-325713-settings-cost-font-size": "20",
                      "product-325713-settings-cost-text": "{{points}} POINTS",
                      "product-325713-settings-hidden": "false",
                      "product-325713-settings-out-of-stock": "false",
                      "product-325713-settings-redeem-button-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-text": "REDEEM NOW",
                      "product-325713-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-type": "rectangular_outline",
                      "product-325713-settings-restrict-specific-tier": "false",
                      "product-325713-settings-reward": "Yankee Rose",
                      "product-325713-settings-reward-color": "#011247",
                      "product-325713-settings-reward-font-size": "18",
                      "product-325713-settings-show-in-logged-out": "No",
                      "product-325713-settings-show-vip-tier-label": "false",
                      "product-325713-settings-variant-id": "16999172243525",
                      "product-325713-settings-vip-tier-label": "VIP ONLY",
                      "product-325714-displayname": "Sunz Up",
                      "product-325714-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-has-shadow": false,
                      "product-325714-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11740_1581628990.original.jpg?1581628990",
                      "product-325714-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325714-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325714-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325714-settings-cost": 200,
                      "product-325714-settings-cost-font-size": "20",
                      "product-325714-settings-cost-text": "{{points}} POINTS",
                      "product-325714-settings-hidden": "false",
                      "product-325714-settings-out-of-stock": "false",
                      "product-325714-settings-redeem-button-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-text": "REDEEM NOW",
                      "product-325714-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-type": "rectangular_outline",
                      "product-325714-settings-restrict-specific-tier": "false",
                      "product-325714-settings-reward": "Sunz Up",
                      "product-325714-settings-reward-color": "#011247",
                      "product-325714-settings-reward-font-size": "18",
                      "product-325714-settings-show-in-logged-out": "No",
                      "product-325714-settings-show-vip-tier-label": "false",
                      "product-325714-settings-variant-id": "29442975629381",
                      "product-325714-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "selected-extensions": [
                        "325713",
                        "325714"
                      ],
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "33271": {
                    instanceId: "33271",
                    instanceVersionId: "261575035",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v0.6.2-5198.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "NO",
                      "confirmation-step-confirm-option": "YES",
                      "confirmation-step-title": "ARE YOU SURE?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout.",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "COPIED",
                      "coupons-redemption-description": "Redeeming your points is easy! Click Redeem My Points and copy \u0026 paste your code at checkout.",
                      "coupons-redemption-headline": "How to use your points",
                      "coupons-redemption-rule": "100 points equals $15",
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "disabled-outline-button-color": "#929292",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "DONATE",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "SUCCESS",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "login-button-color": "#556DD8",
                      "login-button-text": "REDEEM MY POINTS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "20",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redeem-button-color": "#556DD8",
                      "redeem-button-text": "REDEEM",
                      "redeem-button-text-color": "white",
                      "redeem-button-type": "filled_rectangle",
                      "redemption-325704-displayname": "$15 Off",
                      "redemption-325704-settings-button-color": "#556DD8",
                      "redemption-325704-settings-button-text": "REDEEM",
                      "redemption-325704-settings-button-text-color": "white",
                      "redemption-325704-settings-button-type": "filled_rectangle",
                      "redemption-325704-settings-call-to-action-button-text": "REDEEM",
                      "redemption-325704-settings-cost": "100",
                      "redemption-325704-settings-cost-color": "#666d8b",
                      "redemption-325704-settings-cost-font-size": "20",
                      "redemption-325704-settings-cost-text": "{{points}} POINTS",
                      "redemption-325704-settings-coupon-cost-font-size": "15",
                      "redemption-325704-settings-coupon-reward-font-size": "29",
                      "redemption-325704-settings-discount-amount-cents": "1500",
                      "redemption-325704-settings-discount-type": "fixed_amount",
                      "redemption-325704-settings-reward": "$15 Off",
                      "redemption-325704-settings-reward-color": "#011247",
                      "redemption-325704-settings-reward-font-size": "30",
                      "redemption-325704-settings-success-message-text": "Discount Applied",
                      "redemption-325705-displayname": "$30 Off",
                      "redemption-325705-settings-button-color": "#0F8383",
                      "redemption-325705-settings-button-text": "Redeem",
                      "redemption-325705-settings-button-text-color": "#FFFFFF",
                      "redemption-325705-settings-button-type": "rounded_filled_rectangle",
                      "redemption-325705-settings-call-to-action-button-text": "Redeem",
                      "redemption-325705-settings-cost": "200",
                      "redemption-325705-settings-cost-color": "#6C6C6C",
                      "redemption-325705-settings-cost-font-size": "16",
                      "redemption-325705-settings-cost-text": "{{points}} points",
                      "redemption-325705-settings-coupon-cost-font-size": "15",
                      "redemption-325705-settings-coupon-reward-font-size": "29",
                      "redemption-325705-settings-discount-amount-cents": "3000",
                      "redemption-325705-settings-discount-type": "fixed_amount",
                      "redemption-325705-settings-reward": "$30 Off",
                      "redemption-325705-settings-reward-color": "#000000",
                      "redemption-325705-settings-reward-font-size": "20",
                      "redemption-325705-settings-success-message-text": "Discount Applied",
                      "redemption-325706-displayname": "$45 Off",
                      "redemption-325706-settings-button-color": "#0F8383",
                      "redemption-325706-settings-button-text": "Redeem",
                      "redemption-325706-settings-button-text-color": "#FFFFFF",
                      "redemption-325706-settings-button-type": "rounded_filled_rectangle",
                      "redemption-325706-settings-call-to-action-button-text": "Redeem",
                      "redemption-325706-settings-cost": "300",
                      "redemption-325706-settings-cost-color": "#6C6C6C",
                      "redemption-325706-settings-cost-font-size": "16",
                      "redemption-325706-settings-cost-text": "{{points}} points",
                      "redemption-325706-settings-coupon-cost-font-size": "15",
                      "redemption-325706-settings-coupon-reward-font-size": "29",
                      "redemption-325706-settings-discount-amount-cents": "4500",
                      "redemption-325706-settings-discount-type": "fixed_amount",
                      "redemption-325706-settings-reward": "$45 Off",
                      "redemption-325706-settings-reward-color": "#000000",
                      "redemption-325706-settings-reward-font-size": "20",
                      "redemption-325706-settings-success-message-text": "Discount Applied",
                      "redemption-325707-displayname": "$60 Off",
                      "redemption-325707-settings-button-color": "#0F8383",
                      "redemption-325707-settings-button-text": "Redeem",
                      "redemption-325707-settings-button-text-color": "#FFFFFF",
                      "redemption-325707-settings-button-type": "rounded_filled_rectangle",
                      "redemption-325707-settings-call-to-action-button-text": "Redeem",
                      "redemption-325707-settings-cost": "400",
                      "redemption-325707-settings-cost-color": "#6C6C6C",
                      "redemption-325707-settings-cost-font-size": "16",
                      "redemption-325707-settings-cost-text": "{{points}} points",
                      "redemption-325707-settings-coupon-cost-font-size": "15",
                      "redemption-325707-settings-coupon-reward-font-size": "29",
                      "redemption-325707-settings-discount-amount-cents": "6000",
                      "redemption-325707-settings-discount-type": "fixed_amount",
                      "redemption-325707-settings-reward": "$60 Off",
                      "redemption-325707-settings-reward-color": "#000000",
                      "redemption-325707-settings-reward-font-size": "20",
                      "redemption-325707-settings-success-message-text": "Discount Applied",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "325704",
                        "325705",
                        "325706",
                        "325707"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "redemptions-only"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "33269": {
                    instanceId: "33269",
                    instanceVersionId: "36737291",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v0.3.3-4897.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "#728be2",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "#011247",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "custom",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-primary-button-url": "/checkout",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "#011247",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "#728be2",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nget 100 points.",
                      "reward-step-1-settings-description-color": "#666d8b",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-title": "SIGN UP",
                      "reward-step-1-settings-title-color": "#011247",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#666d8b",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#b7c6f8",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#011247",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "#666d8b",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#b7c6f8",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "#011247",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "secondary-button-background-color": "#768cdc",
                      "secondary-button-text-color": "#768cdc",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "28411": {
                    instanceId: "28411",
                    instanceVersionId: "261574520",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v1.2.3-4884.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "benefits-font-size": "18px",
                      "benefits-icon-color": "rgb(115,142,217)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "#000000",
                      "card-background-border-color": "#C9CDD9",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "true",
                      "card-separator-color": "#AAAAAA",
                      "card-separator-type": "default",
                      "current-status-bg-color": "#FFFFFF",
                      "current-status-tag": "true",
                      "current-status-text": "Current Status",
                      "current-status-text-color": "#000000",
                      "current-tier-border-color": "#727898",
                      "grid-lines-color": "#ACB5D4",
                      "headline-font-size": "36px",
                      "headline-text-color": "#011247",
                      "layout": "card",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#011247",
                      "progress-bar-secondary-color": "#768cdc",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier Status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "Montserrat@500|https://fonts.googleapis.com/css?family=Montserrat:500\u0026display=swap",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- Show Less",
                      "show-more-text": "+ Show More",
                      "tier-spacing": "small",
                      "tiers-19084-design-header-bg-color": "#FFFFFF",
                      "tiers-19084-design-icon-fill-color": "rgba(108,137,233,1)",
                      "tiers-19084-design-icon-type": "default",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "false",
                      "tiers-19084-design-name-font-size": "20px",
                      "tiers-19084-design-name-text-color": "#000000",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "#6C6C6C",
                      "tiers-19084-text-benefits": "1 Point Per $1||100 points = $15 off||Refer A Friend // Give $20, Get $20",
                      "tiers-19084-text-name": "Motion",
                      "tiers-19084-text-rank": "1",
                      "tiers-19084-text-threshold": "Free to join",
                      "tiers-7971-design-header-bg-color": "#FFFFFF",
                      "tiers-7971-design-icon-fill-color": "rgba(108,137,233,1)",
                      "tiers-7971-design-icon-type": "default",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "false",
                      "tiers-7971-design-name-font-size": "20px",
                      "tiers-7971-design-name-text-color": "#000000",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "#6C6C6C",
                      "tiers-7971-text-benefits": "1 Point Per $1||100 points = $15 off||Refer A Friend // Give $20, Get $20||Power Up Reward||Early Access to New Products||Exclusive Promotions||2x Points on New Drops||Free Shipping Events",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": "1",
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-background-color": "#f5f5f5",
                      "widget-headline": "Blenders Rewards Membership Tiers"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "28410": {
                    instanceId: "28410",
                    instanceVersionId: "41944023",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v1.2.3-4884.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "benefits-font-size": "18px",
                      "benefits-icon-color": "rgb(115,142,217)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "#000000",
                      "card-background-border-color": "#C9CDD9",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "true",
                      "card-separator-color": "#AAAAAA",
                      "card-separator-type": "default",
                      "current-status-bg-color": "#FFFFFF",
                      "current-status-text-color": "#000000",
                      "current-tier-border-color": "#727898",
                      "grid-lines-color": "#ACB5D4",
                      "headline-font-size": "36px",
                      "headline-text-color": "#011247",
                      "layout": "card",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#011247",
                      "progress-bar-secondary-color": "#768cdc",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier Status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "Montserrat@500|https://fonts.googleapis.com/css?family=Montserrat:500\u0026display=swap",
                      "selected-extensions": [
                        "19084",
                        "7971"
                      ],
                      "show-less-text": "- Show Less",
                      "show-more-text": "+ Show More",
                      "tier-spacing": "big",
                      "tiers-19084-design-header-bg-color": "#FFFFFF",
                      "tiers-19084-design-icon-fill-color": "#0F8383",
                      "tiers-19084-design-icon-type": "default",
                      "tiers-19084-design-icon-url": "",
                      "tiers-19084-design-include-header-bg": "false",
                      "tiers-19084-design-name-font-size": "20px",
                      "tiers-19084-design-name-text-color": "#000000",
                      "tiers-19084-design-threshold-font-size": "16px",
                      "tiers-19084-design-threshold-text-color": "#6C6C6C",
                      "tiers-19084-text-benefits": "Benefit 1||Benefit 2||Benefit 3",
                      "tiers-19084-text-name": "Motion",
                      "tiers-19084-text-rank": 1,
                      "tiers-19084-text-threshold": "",
                      "tiers-7971-design-header-bg-color": "#FFFFFF",
                      "tiers-7971-design-icon-fill-color": "#0F8383",
                      "tiers-7971-design-icon-type": "default",
                      "tiers-7971-design-icon-url": "",
                      "tiers-7971-design-include-header-bg": "false",
                      "tiers-7971-design-name-font-size": "20px",
                      "tiers-7971-design-name-text-color": "#000000",
                      "tiers-7971-design-threshold-font-size": "16px",
                      "tiers-7971-design-threshold-text-color": "#6C6C6C",
                      "tiers-7971-text-benefits": "Benefit 1||Benefit 2||Benefit 3",
                      "tiers-7971-text-name": "Power",
                      "tiers-7971-text-rank": 2,
                      "tiers-7971-text-threshold": "Spend {{amount_spent}}",
                      "widget-background-color": "#f5f5f5",
                      "widget-headline": "The VIP Club"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "24423": {
                    instanceId: "24423",
                    instanceVersionId: "286135046",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-products-redemption/app.v0.6.9-6758.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "#000000",
                      "apply-button-font-size": "14",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cancel-button-text-color": "#0f0c6d",
                      "confirm-button-color": "#0f0c6d",
                      "confirm-button-text-color": "#ffffff",
                      "confirm-button-type": "filled_rectangle",
                      "confirmation-step-cancel-option": "CANCEL",
                      "confirmation-step-confirm-option": "YES, ADD IT",
                      "confirmation-step-title": "Add this item to your cart?",
                      "cost-color": "#a0abf0",
                      "cost-font-size": "20",
                      "cost-text-redemption": "{{points}} POINTS",
                      "desktop-slides-per-view": 4,
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-point-balance-color": "#000000",
                      "dropdown-point-balance-number-color": "#000000",
                      "dropdown-text": "Choose product",
                      "go-back-text": "GO BACK",
                      "has-free-product-failure": "You can only redeem one free product per purchase",
                      "has-no-paid-product-failure": "Add at least one paid product to your cart in order to redeem",
                      "headline": "Redeem for Products",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "image-ratio": "three_four",
                      "login-button-color": "#0f0c6d",
                      "login-button-text": "REDEEM NOW",
                      "login-button-text-color": "#0f0c6d",
                      "login-button-type": "rectangular_outline",
                      "mobile-items-per-slide": 4,
                      "out-of-stock-background-color": "rgba(255,255,255,0.64)",
                      "out-of-stock-text": "OUT OF STOCK",
                      "out-of-stock-text-color": "#011247",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "34",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "product-325713-displayname": "Yankee Rose",
                      "product-325713-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325713-settings-background-has-shadow": false,
                      "product-325713-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11666_1581461608.original.jpg?1581461608",
                      "product-325713-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-color": "#0f0c6d",
                      "product-325713-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325713-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325713-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325713-settings-cost": 250,
                      "product-325713-settings-cost-text": "{{points}} POINTS",
                      "product-325713-settings-hidden": "false",
                      "product-325713-settings-out-of-stock": "false",
                      "product-325713-settings-redeem-button-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-text": "REDEEM NOW",
                      "product-325713-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325713-settings-redeem-button-type": "rectangular_outline",
                      "product-325713-settings-restrict-specific-tier": "false",
                      "product-325713-settings-reward": "Yankee Rose",
                      "product-325713-settings-reward-color": "#011247",
                      "product-325713-settings-reward-font-size": "8",
                      "product-325713-settings-show-in-logged-out": "No",
                      "product-325713-settings-show-vip-tier-label": "false",
                      "product-325713-settings-variant-id": "16999172243525",
                      "product-325713-settings-vip-tier-label": "VIP ONLY",
                      "product-325714-displayname": "Sunz Up",
                      "product-325714-settings-background-border-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-fill-color": "rgba(0,0,0,0)",
                      "product-325714-settings-background-has-shadow": false,
                      "product-325714-settings-background-image-url": "https://cdn-swell-paperclip.yotpo.com/images/images/11740_1581628990.original.jpg?1581628990",
                      "product-325714-settings-cancel-button-text-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-color": "#0f0c6d",
                      "product-325714-settings-confirm-button-text-color": "#FFFFFF",
                      "product-325714-settings-confirmation-step-cancel-option": "CANCEL",
                      "product-325714-settings-confirmation-step-confirm-option": "YES, ADD IT",
                      "product-325714-settings-cost": 200,
                      "product-325714-settings-cost-text": "{{points}} POINTS",
                      "product-325714-settings-hidden": "false",
                      "product-325714-settings-out-of-stock": "false",
                      "product-325714-settings-redeem-button-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-text": "REDEEM NOW",
                      "product-325714-settings-redeem-button-text-color": "#0f0c6d",
                      "product-325714-settings-redeem-button-type": "rectangular_outline",
                      "product-325714-settings-restrict-specific-tier": "false",
                      "product-325714-settings-reward": "Sunz Up",
                      "product-325714-settings-reward-color": "#011247",
                      "product-325714-settings-reward-font-size": "8",
                      "product-325714-settings-show-in-logged-out": "No",
                      "product-325714-settings-show-vip-tier-label": "false",
                      "product-325714-settings-variant-id": "29442975629381",
                      "product-325714-settings-vip-tier-label": "VIP ONLY",
                      "redeem-button-color": "#0f0c6d",
                      "redeem-button-text": "REDEEM NOW",
                      "redeem-button-text-color": "#0f0c6d",
                      "redeem-button-type": "rectangular_outline",
                      "redemptions-background-fill-color": "#ffffff",
                      "redemptions-background-has-shadow": false,
                      "reward-color": "#011247",
                      "reward-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "selected-extensions": [
                        "325713",
                        "325714"
                      ],
                      "status-failure-text": "We could not add this product to your cart",
                      "status-success-text": "Product has been successfully added to your cart",
                      "view-cart-link": "/cart",
                      "view-cart-text": "VIEW CART"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login"
                    },
                    className: "ProductsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "24422": {
                    instanceId: "24422",
                    instanceVersionId: "261574297",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_19_46_488",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-title": "GIVE $20, GET $20",
                      "default-toggle": true,
                      "description-color": "rgba( 55, 51, 48, 1 )",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "header-color": "rgba( 0, 0, 0, 1 )",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba( 85, 131, 66, 1 )",
                      "next-button-font-size": "18px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba( 85, 131, 66, 1 )",
                      "next-button-type": "rectangular_outline",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-description": "You’ll love {{company_name}} as much as I do",
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba( 255, 255, 255, 1 )",
                      "title-color": "rgba( 55, 51, 48, 1 )",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "24421": {
                    instanceId: "24421",
                    instanceVersionId: "25754451",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v0.13.0-4770.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-522517-background-color": "#f9faff",
                      "campaign-item-522517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522517-background-type": "color",
                      "campaign-item-522517-border-color": "#848ca3",
                      "campaign-item-522517-description-font-color": "#4e5772",
                      "campaign-item-522517-description-font-size": "18",
                      "campaign-item-522517-exclude_audience_names": "",
                      "campaign-item-522517-hover-view-tile-message": "Earn 25 points for being one of the first to join our rewards program!",
                      "campaign-item-522517-icon-color": "#768cdc",
                      "campaign-item-522517-icon-type": "defaultIcon",
                      "campaign-item-522517-include_audience_ids": "1",
                      "campaign-item-522517-include_audience_names": "All customers",
                      "campaign-item-522517-special-reward-enabled": "false",
                      "campaign-item-522517-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522517-special-reward-headline-text": "Just for you!",
                      "campaign-item-522517-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522517-special-reward-headline-title-font-size": "16",
                      "campaign-item-522517-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522517-tile-description": "Sign up to Join",
                      "campaign-item-522517-tile-reward": "25 Points",
                      "campaign-item-522517-title-font-color": "#011247",
                      "campaign-item-522517-title-font-size": "27",
                      "campaign-item-522517-type": "CreateAccountCampaign",
                      "campaign-item-522518-background-color": "#f9faff",
                      "campaign-item-522518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522518-background-type": "color",
                      "campaign-item-522518-border-color": "#848ca3",
                      "campaign-item-522518-description-font-color": "#4e5772",
                      "campaign-item-522518-description-font-size": "18",
                      "campaign-item-522518-exclude_audience_names": "",
                      "campaign-item-522518-hover-view-tile-message": "Earn 1 point for every $1 you spend in our store",
                      "campaign-item-522518-icon-color": "#768cdc",
                      "campaign-item-522518-icon-type": "defaultIcon",
                      "campaign-item-522518-include_audience_ids": "1",
                      "campaign-item-522518-include_audience_names": "All customers",
                      "campaign-item-522518-special-reward-enabled": "false",
                      "campaign-item-522518-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522518-special-reward-headline-text": "Just for you!",
                      "campaign-item-522518-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522518-special-reward-headline-title-font-size": "16",
                      "campaign-item-522518-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522518-tile-description": "Make a purchase",
                      "campaign-item-522518-tile-reward": "1 Point Per $1",
                      "campaign-item-522518-title-font-color": "#011247",
                      "campaign-item-522518-title-font-size": "27",
                      "campaign-item-522518-type": "PointsForPurchasesCampaign",
                      "campaign-item-522519-action-tile-action-text": "Add My Birthday",
                      "campaign-item-522519-action-tile-ask-year": "true",
                      "campaign-item-522519-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-522519-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-522519-action-tile-european-date-format": "false",
                      "campaign-item-522519-action-tile-message-text": " If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-522519-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-522519-action-tile-title": "Earn 100 points on your Birthday!",
                      "campaign-item-522519-background-color": "#f9faff",
                      "campaign-item-522519-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522519-background-type": "color",
                      "campaign-item-522519-border-color": "#848ca3",
                      "campaign-item-522519-description-font-color": "#4e5772",
                      "campaign-item-522519-description-font-size": "18",
                      "campaign-item-522519-exclude_audience_names": "",
                      "campaign-item-522519-icon-color": "#768cdc",
                      "campaign-item-522519-icon-type": "defaultIcon",
                      "campaign-item-522519-include_audience_ids": "1",
                      "campaign-item-522519-include_audience_names": "All customers",
                      "campaign-item-522519-special-reward-enabled": "false",
                      "campaign-item-522519-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522519-special-reward-headline-text": "Just for you!",
                      "campaign-item-522519-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522519-special-reward-headline-title-font-size": "16",
                      "campaign-item-522519-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522519-tile-description": "Happy Birthday",
                      "campaign-item-522519-tile-reward": "Earn 100 points on your Birthday!",
                      "campaign-item-522519-title-font-color": "#011247",
                      "campaign-item-522519-title-font-size": "27",
                      "campaign-item-522519-type": "BirthdayCampaign",
                      "campaign-item-522732-background-color": "#f9faff",
                      "campaign-item-522732-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522732-background-type": "color",
                      "campaign-item-522732-border-color": "#848ca3",
                      "campaign-item-522732-description-font-color": "#4e5772",
                      "campaign-item-522732-description-font-size": "18",
                      "campaign-item-522732-exclude_audience_names": "",
                      "campaign-item-522732-hover-view-tile-message": "Earn 50 points when you spend over $100 at our store",
                      "campaign-item-522732-icon-color": "#768cdc",
                      "campaign-item-522732-icon-type": "defaultIcon",
                      "campaign-item-522732-include_audience_ids": "1",
                      "campaign-item-522732-include_audience_names": "All customers",
                      "campaign-item-522732-special-reward-enabled": "false",
                      "campaign-item-522732-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522732-special-reward-headline-text": "Just for you!",
                      "campaign-item-522732-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522732-special-reward-headline-title-font-size": "16",
                      "campaign-item-522732-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522732-tile-description": "Spend Over $100",
                      "campaign-item-522732-tile-reward": "50 Points",
                      "campaign-item-522732-title-font-color": "#011247",
                      "campaign-item-522732-title-font-size": "27",
                      "campaign-item-522732-type": "SpendBasedCampaign",
                      "campaign-item-522733-background-color": "#f9faff",
                      "campaign-item-522733-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522733-background-type": "color",
                      "campaign-item-522733-border-color": "#848ca3",
                      "campaign-item-522733-description-font-color": "#4e5772",
                      "campaign-item-522733-description-font-size": "18",
                      "campaign-item-522733-exclude_audience_names": "",
                      "campaign-item-522733-hover-view-tile-message": "Earn 75 points when you spend over $150 at our store",
                      "campaign-item-522733-icon-color": "#768cdc",
                      "campaign-item-522733-icon-type": "defaultIcon",
                      "campaign-item-522733-include_audience_ids": "1",
                      "campaign-item-522733-include_audience_names": "All customers",
                      "campaign-item-522733-special-reward-enabled": "false",
                      "campaign-item-522733-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522733-special-reward-headline-text": "Just for you!",
                      "campaign-item-522733-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522733-special-reward-headline-title-font-size": "16",
                      "campaign-item-522733-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522733-tile-description": "Spend Over $150",
                      "campaign-item-522733-tile-reward": "75 Points",
                      "campaign-item-522733-title-font-color": "#011247",
                      "campaign-item-522733-title-font-size": "27",
                      "campaign-item-522733-type": "SpendBasedCampaign",
                      "campaign-item-522735-action-tile-action-text": "Follow Us",
                      "campaign-item-522735-action-tile-title": "Earn 5 points when you follow us on Instagram",
                      "campaign-item-522735-background-color": "#f9faff",
                      "campaign-item-522735-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522735-background-type": "color",
                      "campaign-item-522735-border-color": "#848ca3",
                      "campaign-item-522735-description-font-color": "#4e5772",
                      "campaign-item-522735-description-font-size": "18",
                      "campaign-item-522735-exclude_audience_names": "",
                      "campaign-item-522735-icon-color": "#768cdc",
                      "campaign-item-522735-icon-type": "defaultIcon",
                      "campaign-item-522735-include_audience_ids": "1",
                      "campaign-item-522735-include_audience_names": "All customers",
                      "campaign-item-522735-special-reward-enabled": "false",
                      "campaign-item-522735-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522735-special-reward-headline-text": "Just for you!",
                      "campaign-item-522735-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522735-special-reward-headline-title-font-size": "16",
                      "campaign-item-522735-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522735-tile-description": "Follow us on Instagram",
                      "campaign-item-522735-tile-reward": "5 Points",
                      "campaign-item-522735-title-font-color": "#011247",
                      "campaign-item-522735-title-font-size": "27",
                      "campaign-item-522735-type": "InstagramFollowCampaign",
                      "campaign-item-522736-action-tile-action-text": "Follow us",
                      "campaign-item-522736-action-tile-title": "Earn 5 points when you visit our Facebook page",
                      "campaign-item-522736-background-color": "#f9faff",
                      "campaign-item-522736-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522736-background-type": "color",
                      "campaign-item-522736-border-color": "#848ca3",
                      "campaign-item-522736-description-font-color": "#4e5772",
                      "campaign-item-522736-description-font-size": "18",
                      "campaign-item-522736-exclude_audience_names": "",
                      "campaign-item-522736-icon-color": "#768cdc",
                      "campaign-item-522736-icon-type": "defaultIcon",
                      "campaign-item-522736-include_audience_ids": "1",
                      "campaign-item-522736-include_audience_names": "All customers",
                      "campaign-item-522736-special-reward-enabled": "false",
                      "campaign-item-522736-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-522736-special-reward-headline-text": "Just for you!",
                      "campaign-item-522736-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-522736-special-reward-headline-title-font-size": "16",
                      "campaign-item-522736-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-522736-tile-description": "Follow us on Facebook",
                      "campaign-item-522736-tile-reward": "5 Points",
                      "campaign-item-522736-title-font-color": "#011247",
                      "campaign-item-522736-title-font-size": "27",
                      "campaign-item-522736-type": "FacebookPageVisitCampaign",
                      "campaign-item-522737-action-tile-action-text": "Follow Us",
                      "campaign-item-522737-action-tile-title": "Earn 5 points when you follow us on Twitter",
                      "campaign-item-522737-background-color": "#f9faff",
                      "campaign-item-522737-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-522737-background-type": "color",
                      "campaign-item-522737-border-color": "#848ca3",
                      "campaign-item-522737-description-font-color": "#4e5772",
                      "campaign-item-522737-description-font-size": "18",
                      "campaign-item-522737-displayname": "campaign-item-522737",
                      "campaign-item-522737-icon-color": "#768cdc",
                      "campaign-item-522737-icon-type": "defaultIcon",
                      "campaign-item-522737-tile-description": "Follow us on Twitter",
                      "campaign-item-522737-tile-reward": "5 Points",
                      "campaign-item-522737-title-font-color": "#011247",
                      "campaign-item-522737-title-font-size": "27",
                      "campaign-item-522737-type": "TwitterFollowCampaign",
                      "campaign-item-522737-view-show-custom-action-button": "false",
                      "campaign-item-525059-action-tile-action-text": "Click Here",
                      "campaign-item-525059-action-tile-title": "Earn 10 points by writing us a review on Facebook and sending a screenshot of your review to mermaids@blenderseyewear.com",
                      "campaign-item-525059-background-color": "#f9faff",
                      "campaign-item-525059-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525059-background-type": "color",
                      "campaign-item-525059-border-color": "#848ca3",
                      "campaign-item-525059-description-font-color": "#4e5772",
                      "campaign-item-525059-description-font-size": "18",
                      "campaign-item-525059-displayname": "campaign-item-525059",
                      "campaign-item-525059-icon-color": "#768cdc",
                      "campaign-item-525059-icon-type": "defaultIcon",
                      "campaign-item-525059-tile-description": "Review us on Facebook",
                      "campaign-item-525059-tile-reward": "10 Points",
                      "campaign-item-525059-title-font-color": "#011247",
                      "campaign-item-525059-title-font-size": "27",
                      "campaign-item-525059-type": "CustomActionCampaign",
                      "campaign-item-525059-view-show-custom-action-button": "false",
                      "campaign-item-525098-background-color": "#f9faff",
                      "campaign-item-525098-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-525098-background-type": "color",
                      "campaign-item-525098-border-color": "#848ca3",
                      "campaign-item-525098-description-font-color": "#4e5772",
                      "campaign-item-525098-description-font-size": "18",
                      "campaign-item-525098-exclude_audience_names": "",
                      "campaign-item-525098-hover-view-tile-message": "Earn 5 points for leaving a review! Simply, navigate to the review section of the product you recently purchased and click \"Write a Review\".",
                      "campaign-item-525098-icon-color": "#768cdc",
                      "campaign-item-525098-icon-type": "defaultIcon",
                      "campaign-item-525098-include_audience_ids": "1",
                      "campaign-item-525098-include_audience_names": "All customers",
                      "campaign-item-525098-special-reward-enabled": "false",
                      "campaign-item-525098-special-reward-headline-background-color": "#E0DBEF",
                      "campaign-item-525098-special-reward-headline-text": "Just for you!",
                      "campaign-item-525098-special-reward-headline-title-font-color": "#5344A6",
                      "campaign-item-525098-special-reward-headline-title-font-size": "16",
                      "campaign-item-525098-special-reward-tile-border-color": "#8270E7",
                      "campaign-item-525098-tile-description": "Leave a Review",
                      "campaign-item-525098-tile-reward": "5 points",
                      "campaign-item-525098-title-font-color": "#011247",
                      "campaign-item-525098-title-font-size": "27",
                      "campaign-item-525098-type": "YotpoReviewCampaign",
                      "campaign-item-582318-action-tile-action-text": "Click here",
                      "campaign-item-582318-action-tile-title": "Earn points for an action",
                      "campaign-item-582318-background-color": "#f9faff",
                      "campaign-item-582318-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-582318-background-type": "color",
                      "campaign-item-582318-border-color": "#848ca3",
                      "campaign-item-582318-description-font-color": "#4e5772",
                      "campaign-item-582318-description-font-size": "18",
                      "campaign-item-582318-displayname": "campaign-item-582318",
                      "campaign-item-582318-hover-view-tile-message": "Upload a photo with your next review and earn 20 points",
                      "campaign-item-582318-icon-color": "#768cdc",
                      "campaign-item-582318-icon-type": "defaultIcon",
                      "campaign-item-582318-tile-description": "Add photo in Review",
                      "campaign-item-582318-tile-reward": "20 points",
                      "campaign-item-582318-title-font-color": "#011247",
                      "campaign-item-582318-title-font-size": "27",
                      "campaign-item-582318-type": "YotpoReviewImageCampaign",
                      "campaign-item-582318-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to earn points",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "#140060",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "#011247",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "#011247",
                      "headline-font-size": "36px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "522517",
                        "522735",
                        "522737",
                        "522736",
                        "525059",
                        "525098",
                        "582318",
                        "522518",
                        "522732",
                        "522733",
                        "522519"
                      ],
                      "tile-border-color": "#848ca3",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeAccountRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "24420": {
                    instanceId: "24420",
                    instanceVersionId: "261574299",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v0.2.1-4807.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_15_59_898",
                      "description-color": "rgba(44,44,44,1)",
                      "description-font-size": "20",
                      "description-text-logged-in": "As a member you'll earn points \u0026 exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points \u0026 exclusive rewards every time you shop.",
                      "headline-color": "rgba(0,0,0,1)",
                      "headline-font-size": "40",
                      "headline-text-logged-in": "Welcome to Blenders Rewards",
                      "headline-text-logged-out": "Blenders Rewards",
                      "login-button-color": "rgba(44,44,44,1)",
                      "login-button-text": "LOGIN",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "rectangular_outline",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2024_06_20_18_18_20_582",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "register-button-color": "rgba(0,0,0,1)",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "rgba(255,255,255,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "//www.blenderseyewear.com/account/login",
                      "storeRegistrationUrl": "//www.blenderseyewear.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "24419": {
                    instanceId: "24419",
                    instanceVersionId: "36737283",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v0.3.3-4897.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "#728be2",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "#011247",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "#011247",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "primary-button-background-color": "#728be2",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nget 100 points.",
                      "reward-step-1-settings-description-color": "#666d8b",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-title": "SIGN UP",
                      "reward-step-1-settings-title-color": "#011247",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#666d8b",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#b7c6f8",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "#011247",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "#666d8b",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#b7c6f8",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "#011247",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "secondary-button-background-color": "#768cdc",
                      "secondary-button-text-color": "#768cdc",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "24418": {
                    instanceId: "24418",
                    instanceVersionId: "30991734",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v0.6.2-5198.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "NO",
                      "confirmation-step-confirm-option": "YES",
                      "confirmation-step-title": "ARE YOU SURE?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout.",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "COPIED",
                      "coupons-redemption-description": "Redeeming your points is easy! Click Redeem My Points and copy \u0026 paste your code at checkout.",
                      "coupons-redemption-headline": "How to use your points",
                      "coupons-redemption-rule": "100 points equals $10.00",
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "disabled-outline-button-color": "#929292",
                      "donate-button-text": "DONATE",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "SUCCESS",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "login-button-color": "#556DD8",
                      "login-button-text": "REDEEM MY POINTS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "20",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redeem-button-color": "#556DD8",
                      "redeem-button-text": "REDEEM",
                      "redeem-button-text-color": "white",
                      "redeem-button-type": "filled_rectangle",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [],
                      "subscription-coupon-applied-message-body": "A coupon was applied to your next subscription order. You'll be able to redeem another coupon after the next charge will occur.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "24417": {
                    instanceId: "24417",
                    instanceVersionId: "261575051",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v0.6.1-4815.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "layout-background-color": "white",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "100 points",
                      "redemption-1-settings-cost-color": "#666d8b",
                      "redemption-1-settings-cost-font-size": "20",
                      "redemption-1-settings-reward": "$15 Off",
                      "redemption-1-settings-reward-color": "#011247",
                      "redemption-1-settings-reward-font-size": "30",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "200 points",
                      "redemption-2-settings-cost-color": "#666d8b",
                      "redemption-2-settings-cost-font-size": "20",
                      "redemption-2-settings-reward": "$30 Off",
                      "redemption-2-settings-reward-color": "#011247",
                      "redemption-2-settings-reward-font-size": "30",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "300 points",
                      "redemption-3-settings-cost-color": "#666d8b",
                      "redemption-3-settings-cost-font-size": "20",
                      "redemption-3-settings-reward": "$45 Off",
                      "redemption-3-settings-reward-color": "#011247",
                      "redemption-3-settings-reward-font-size": "30",
                      "redemption-971930-displayname": "Tile4 (971930)",
                      "redemption-971930-settings-cost": "400 points",
                      "redemption-971930-settings-cost-color": "#666d8b",
                      "redemption-971930-settings-cost-font-size": "20",
                      "redemption-971930-settings-reward": "$60 Off",
                      "redemption-971930-settings-reward-color": "#011247",
                      "redemption-971930-settings-reward-font-size": "30",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3",
                        "971930"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your hard-earned points is easy! Simply apply your points for a discount at checkout!",
                      "visual-redemption-headline": "How to use your points",
                      "visual-redemption-rule": "100 points equals $15.00"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "24359": {
                    instanceId: "24359",
                    instanceVersionId: "9734083",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-checkout-redemptions/app.v0.2.77-3739.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CheckoutRedemptionsWidget/VurgePV_lmerI49HhCiiPQ/css-overrides/css-overrides.2021_02_02_16_36_28_727.css",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-button-color": "rgba(32,128,236,1)",
                      "apply-button-text": "Apply",
                      "apply-button-text-color": "#ffffff",
                      "apply-button-type": "rounded_filled_rectangle",
                      "cart-amount-below-min-background-color": "#fff",
                      "cart-amount-below-min-font-size": "14",
                      "cart-amount-below-min-text": "Use your points on purchases of {{cart_minimum_amount}} or more. Add another {{cart_missing_amount}} to your cart to use your points!",
                      "cart-amount-below-min-text-color": "#050f50",
                      "dropdown-border-color": "#848ca3",
                      "dropdown-border-radius": "2px",
                      "dropdown-text": "Choose reward",
                      "headline-color": "rgba(83,83,83,1)",
                      "headline-font-size": 14,
                      "headline-text": "You have {{current_point_balance}} Points",
                      "not-enough-points-text": "Bummer, you don't have enough points to redeem.",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700\u0026display=swap",
                      "redemption-325704-cart-greater-than-cents": "1500",
                      "redemption-325704-cost-in-points": "100",
                      "redemption-325704-cost-text": "100 Points",
                      "redemption-325704-currency-symbol": "$",
                      "redemption-325704-discount-amount-cents": "1500",
                      "redemption-325704-discount-type": "fixed_amount",
                      "redemption-325704-name": "$15 Off",
                      "redemption-325704-subunit-to-unit": "100",
                      "redemption-325704-type": "Coupon",
                      "redemption-325704-unrendered-name": "$15 Off",
                      "redemption-325705-cart-greater-than-cents": "3000",
                      "redemption-325705-cost-in-points": "200",
                      "redemption-325705-cost-text": "200 Points",
                      "redemption-325705-currency-symbol": "$",
                      "redemption-325705-discount-amount-cents": "3000",
                      "redemption-325705-discount-type": "fixed_amount",
                      "redemption-325705-name": "$30 Off",
                      "redemption-325705-subunit-to-unit": "100",
                      "redemption-325705-type": "Coupon",
                      "redemption-325705-unrendered-name": "$30 Off",
                      "redemption-325706-cart-greater-than-cents": "4500",
                      "redemption-325706-cost-in-points": "300",
                      "redemption-325706-cost-text": "300 Points",
                      "redemption-325706-currency-symbol": "$",
                      "redemption-325706-discount-amount-cents": "4500",
                      "redemption-325706-discount-type": "fixed_amount",
                      "redemption-325706-name": "$45 Off",
                      "redemption-325706-subunit-to-unit": "100",
                      "redemption-325706-type": "Coupon",
                      "redemption-325706-unrendered-name": "$45 Off",
                      "redemption-325707-cart-greater-than-cents": "6000",
                      "redemption-325707-cost-in-points": "400",
                      "redemption-325707-cost-text": "400 Points",
                      "redemption-325707-currency-symbol": "$",
                      "redemption-325707-discount-amount-cents": "6000",
                      "redemption-325707-discount-type": "fixed_amount",
                      "redemption-325707-name": "$60 Off",
                      "redemption-325707-subunit-to-unit": "100",
                      "redemption-325707-type": "Coupon",
                      "redemption-325707-unrendered-name": "$60 Off",
                      "redemption-742932-cart-greater-than-cents": "1500",
                      "redemption-742932-cost-in-points": "100",
                      "redemption-742932-cost-text": "100 points",
                      "redemption-742932-currency-symbol": "$",
                      "redemption-742932-discount-amount-cents": "1500",
                      "redemption-742932-discount-type": "fixed_amount",
                      "redemption-742932-name": "$15 off",
                      "redemption-742932-subunit-to-unit": "100",
                      "redemption-742932-type": "Coupon",
                      "redemption-742932-unrendered-name": "$15 off",
                      "secondary-font-name-and-url": "Open Sans@400|https://fonts.googleapis.com/css?family=Open+Sans:400\u0026display=swap",
                      "selected-redemption-options": [
                        "325707",
                        "325706",
                        "325705",
                        "325704"
                      ],
                      "shopify-expand-order-section": "true"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "58582",
                      "platformName": "shopify"
                    },
                    className: "CheckoutRedemptionsWidget",
                    dependencyGroupId: null
                },
            
                "2596": {
                    instanceId: "2596",
                    instanceVersionId: "29301191",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/VurgePV_lmerI49HhCiiPQ/images/image_2022_01_26_23_03_43_647",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $30 off their first order of $50 and get $30 (in points) for each successful referral",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-title": "GIVE $30, GET $30",
                      "default-toggle": true,
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-name-and-url": "Open Sans#https://fonts.googleapis.com/css?family=Open+Sans\u0026display=swap",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Nunito Sans#https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans#https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "header-color": "rgba(255,255,255,1)",
                      "header-font-name-and-url": "Open Sans#https://fonts.googleapis.com/css?family=Open+Sans\u0026display=swap",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_email",
                      "next-button-background-color": "rgba(0,120,212,1)",
                      "next-button-font-size": "18px",
                      "next-button-size": "small",
                      "next-button-text-color": "rgba(255,255,255,1)",
                      "next-button-type": "filled_rectangle",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $30 off their first order of $50 and get $30 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $30, GET $30",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-description": "You’ll love {{company_name}} as much as I do",
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(255,255,255,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(255,255,255,0)",
                      "title-color": "rgba(255,255,255,1)",
                      "title-font-name-and-url": "Open Sans#https://fonts.googleapis.com/css?family=Open+Sans\u0026display=swap",
                      "title-font-size": "28px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "false",
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_2"
                    },
                    staticContent: {
                      "companyName": "Blenders Eyewear ",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "merchantId": "58582",
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
            },
            guidStaticContent: {},
            dependencyGroups: {
                      "2": [
                        "https://cdn-widget-assets.yotpo.com/widget-vue-core/app.v0.1.0-2295.js"
                      ]
                    }
        },
        initializer: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widgets-initializer/app.v0.9.2-6545.js",
        analytics: "https://cdn-widgetsrepository.yotpo.com/widget-assets/yotpo-pixel/2024-04-18_14-53-12/bundle.js"
    }
    
    
    const initWidgets = function (config, initializeWidgets = true) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        return widgetInitializer.initWidgets(initializeWidgets);
    };
    const initWidget = function (config, instanceId, widgetPlaceHolder) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        if (widgetInitializer.initWidget) {
            return widgetInitializer.initWidget(instanceId, widgetPlaceHolder);
        }
        console.error("initWidget is not supported widgetInitializer");
    };
    const onInitializerLoad = function (config) {
        const prevInitWidgets = yotpoWidgetsContainer.initWidgets;
        yotpoWidgetsContainer.initWidgets = function (initializeWidgets = true) {
            if (prevInitWidgets) {
                if (typeof Promise !== 'undefined' && Promise.all) {
                    return Promise.all([prevInitWidgets(initializeWidgets), initWidgets(config, initializeWidgets)]);
                }
                console.warn('[deprecated] promise is not supported in initWidgets');
                prevInitWidgets(initializeWidgets);
            }
            return initWidgets(config, initializeWidgets);
        }
        const prevInitWidget = yotpoWidgetsContainer.initWidget;
        yotpoWidgetsContainer.initWidget = function (instanceId, widgetPlaceHolder) {
            if (prevInitWidget) {
              prevInitWidget(instanceId, widgetPlaceHolder)
            }
            return initWidget(config, instanceId, widgetPlaceHolder);
        }
        const guidWidgetContainer = getGuidWidgetsContainer();
        guidWidgetContainer.initWidgets = function () {
            return initWidgets(config);
        }
        guidWidgetContainer.initWidgets();
    };
    function getGuidWidgetsContainer () {
        if (!yotpoWidgetsContainer.guids) {
            yotpoWidgetsContainer.guids = {};
        }
        if (!yotpoWidgetsContainer.guids[guid]) {
            yotpoWidgetsContainer.guids[guid] = {};
        }
        return yotpoWidgetsContainer.guids[guid];
    }
    function initWidgetsTestingGroupData(guid) {
        const testingGroupData = {};
        const storageUUIDData = sessionStorage.getItem(`${guid}_uuid`);
        const storageTestingData = yotpoWidgetsContainer.testingGroupData;
        if (!storageTestingData) {
            testingGroupData.analyticsId = yotpoWidgetsContainer.GetAnalyticsId();
            const encodedUUID = new TextEncoder().encode(testingGroupData.analyticsId);
            crypto.subtle.digest("SHA-1", encodedUUID).then(hashArrayBuffer => {
                testingGroupData.hash = new Uint8Array(hashArrayBuffer || []);
                yotpoWidgetsContainer.testingGroupData = testingGroupData;
            });
        }
        if (!storageUUIDData) {
            yotpoWidgetsContainer.guids["VurgePV_lmerI49HhCiiPQ"].uuid = "cef96f72-6dc9-4b3e-99c8-3cb6ef5901de";
        }
    }

    const guidWidgetContainer = getGuidWidgetsContainer();
    guidWidgetContainer.config = loader.config;
    if (!guidWidgetContainer.yotpo_widget_scripts_loaded) {
        guidWidgetContainer.yotpo_widget_scripts_loaded = true;
        guidWidgetContainer.onInitializerLoad = function () { onInitializerLoad(loader.config) };
        
        loader.loadDep(loader.analytics, function () {  initWidgetsTestingGroupData(guid); }, 'defer');
        
        
        loader.loadDep(loader.initializer, function () { guidWidgetContainer.onInitializerLoad() }, 'async');
        
    }
})()


